
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("i1BaA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b1da029eb75ad95c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4UoAC = parcelRequire("4UoAC");

var $koVbs = parcelRequire("koVbs");

var $c2JIK = parcelRequire("c2JIK");

var $y8WG5 = parcelRequire("y8WG5");

var $e9YVH = parcelRequire("e9YVH");

var $gq0sA = parcelRequire("gq0sA");

var $jLOUq = parcelRequire("jLOUq");

var $4dRjY = parcelRequire("4dRjY");

var $4orJd = parcelRequire("4orJd");

var $h7sEe = parcelRequire("h7sEe");
const $b1da029eb75ad95c$var$Actions = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ data: pageContextData }] = (0, $gq0sA.usePageContext)();
    const { projectContext: projectContext } = pageContextData || {};
    const { projectKey: projectKey } = projectContext || {};
    if (!projectKey) return;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4UoAC.default), {
        appearance: "primary",
        href: (0, $c2JIK.createReportUrl)(projectKey, '/custom/new')
    }, formatMessage((0, $4orJd.default).newReportButton));
};
const $b1da029eb75ad95c$var$ReportsHomePage = ()=>{
    const { data: features } = (0, $y8WG5.useFeatures)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jLOUq.default), {
        pageId: "reports-home-page",
        appName: (0, $e9YVH.APP_NAMES).REPORTS_HOME_PAGE,
        pageTitle: (0, $4orJd.default).homePageTitle,
        actions: features?.hasReports ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1da029eb75ad95c$var$Actions, null) : undefined
    }, ({ pageContext: pageContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h7sEe.default), {
            pageContext: pageContext
        })));
};
var $b1da029eb75ad95c$export$2e2bcd8739ae039 = $b1da029eb75ad95c$var$ReportsHomePage;

});
parcelRegister("4UoAC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2280edfe0f85b738$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kDFVt = parcelRequire("kDFVt");

var $2Tkjt = parcelRequire("2Tkjt");
const $2280edfe0f85b738$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const baseProps = (0, $2Tkjt.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: 'link',
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kDFVt.default), {
        ...saferRest,
        "aria-label": baseProps['aria-label'],
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        testId: testId,
        /**
			 * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
			 * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
			 */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: baseProps.isDisabled ? undefined : href,
        role: baseProps.isDisabled ? 'link' : undefined,
        "aria-disabled": baseProps.isDisabled === true ? true : undefined,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LinkButton"
    }, baseProps.children);
};
// Workarounds to support generic types with forwardRef + memo
const $2280edfe0f85b738$var$WithRef = /*#__PURE__*/ (0, $5uXOq.forwardRef)($2280edfe0f85b738$var$LinkButtonBase);
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $2280edfe0f85b738$var$LinkButton = /*#__PURE__*/ (0, $5uXOq.memo)($2280edfe0f85b738$var$WithRef);
var $2280edfe0f85b738$export$2e2bcd8739ae039 = $2280edfe0f85b738$var$LinkButton;

});

parcelRegister("c2JIK", function(module, exports) {

$parcel$export(module.exports, "createReportUrl", () => $ff6ef038ac5edc5a$export$58ea1e106226fd1e);
$parcel$export(module.exports, "useLegacySpaClickHandler", () => $ff6ef038ac5edc5a$export$688261d7167cb6e9);

var $5uXOq = parcelRequire("5uXOq");

var $6BZYo = parcelRequire("6BZYo");
const $ff6ef038ac5edc5a$export$58ea1e106226fd1e = (projectKey, reportType)=>`${__SPA__ ? '/jira/servicedesk' : ''}/projects/${projectKey}/reports${reportType}`;
const $ff6ef038ac5edc5a$export$688261d7167cb6e9 = ()=>{
    const pushStateNavigatorRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $6BZYo.loadBridge)({
            name: 'servicedesk/internal-api/core/util/push-state-navigator/push-state-navigator',
            shouldLogError: false
        }).then((result)=>{
            pushStateNavigatorRef.current = result;
        }).catch(()=>{
        // silently dies when the required module is not available in this context
        });
    });
    return (0, $5uXOq.useCallback)((e)=>{
        const href = // @ts-expect-error - TS2339 - Property 'href' does not exist on type 'EventTarget | (EventTarget & Element) | (EventTarget & HTMLAnchorElement)'. | TS2339 - Property 'href' does not exist on type 'EventTarget | (EventTarget & Element) | (EventTarget & HTMLAnchorElement)'.
        typeof e.currentTarget.href === 'string' ? e.currentTarget.href : undefined;
        const openInNewTab = // @ts-expect-error - TS2339 - Property 'metaKey' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | SyntheticEvent<Element, Event> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<...> | KeyboardEvent<...>'. | TS2339 - Property 'ctrlKey' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | SyntheticEvent<Element, Event> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<...> | KeyboardEvent<...>'. | TS2339 - Property 'button' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | SyntheticEvent<Element, Event> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<...> | KeyboardEvent<...>'. | TS2339 - Property 'button' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | SyntheticEvent<Element, Event> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<...> | KeyboardEvent<...>'.
        e.metaKey === true || e.ctrlKey === true || e.button != null && e.button === 1;
        if (href == null || href === '' || e.defaultPrevented || openInNewTab) return;
        if (pushStateNavigatorRef.current) {
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            const willNavigate = pushStateNavigatorRef.current.navigate(href);
            if (willNavigate) e.preventDefault();
        }
    }, []);
};

});

parcelRegister("y8WG5", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $6f07339a74e499dd$export$4a39035bacc4ed76);
$parcel$export(module.exports, "useReportFeatures", () => $6f07339a74e499dd$export$4adaea9828b7ff13);
$parcel$export(module.exports, "useSettingFeatures", () => $6f07339a74e499dd$export$56022a3b83c8ed6a);
$parcel$export(module.exports, "useTMPSettingFeatures", () => $6f07339a74e499dd$export$e8540ab76a479132);

var $5uXOq = parcelRequire("5uXOq");

var $aQGK8 = parcelRequire("aQGK8");

var $1J3t1 = parcelRequire("1J3t1");

var $jIwth = parcelRequire("jIwth");

var $2tT7R = parcelRequire("2tT7R");

var $kFjc6 = parcelRequire("kFjc6");
const $6f07339a74e499dd$export$4a39035bacc4ed76 = (customContext)=>{
    const { data: data, ...rest } = (0, $1J3t1.useJiraServiceManagementProjectNavigation)(customContext);
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $kFjc6.extractData)(data), [
        data
    ]);
    return {
        data: extractedData,
        ...rest
    };
};
const $6f07339a74e499dd$export$4adaea9828b7ff13 = (customContext)=>{
    const { data: data, ...rest } = (0, $aQGK8.useJiraServiceManagementReportsNavigation)(customContext);
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $kFjc6.extractReportData)(data), [
        data
    ]);
    return {
        data: extractedData,
        ...rest
    };
};
const $6f07339a74e499dd$export$56022a3b83c8ed6a = (customContext)=>{
    const { data: data, ...rest } = (0, $1J3t1.useJiraServiceManagementProjectNavigation)(customContext);
    const hasActiveSoftwareAccess = (0, $jIwth.useHasActiveSoftwareAccess)();
    const environment = (0, $2tT7R.useEnvironment)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $kFjc6.extractSettingData)(data, {
            hasActiveSoftwareAccess: hasActiveSoftwareAccess,
            environment: environment
        }), [
        data,
        environment,
        hasActiveSoftwareAccess
    ]);
    return {
        data: extractedData,
        ...rest
    };
};
const $6f07339a74e499dd$export$e8540ab76a479132 = ()=>{
    const { data: data, ...rest } = (0, $1J3t1.useJiraServiceManagementProjectNavigation)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $kFjc6.extractTMPSettingData)(data), [
        data
    ]);
    return {
        data: extractedData,
        ...rest
    };
};

});
parcelRegister("aQGK8", function(module, exports) {

$parcel$export(module.exports, "useJiraServiceManagementReportsNavigation", () => $8d8e651293539c9e$export$6d172fb6aa6b6b5b);

var $gS5PF = parcelRequire("gS5PF");

var $324W5 = parcelRequire("324W5");
const $8d8e651293539c9e$export$6d172fb6aa6b6b5b = (customContext)=>(0, $324W5.useResourceWithCustomRouterContext)((0, $gS5PF.staticSidebarJsmReportsResource), customContext);

});

parcelRegister("kFjc6", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $d21447ab73114105$export$9df5fa0a366163d2);
$parcel$export(module.exports, "extractReportData", () => $d21447ab73114105$export$86f3b0e5fff6482e);
$parcel$export(module.exports, "extractSettingData", () => $d21447ab73114105$export$a1d86e289d0f43b7);
$parcel$export(module.exports, "extractTMPSettingData", () => $d21447ab73114105$export$d334c13580163a89);

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");
const $d21447ab73114105$export$9df5fa0a366163d2 = (navData)=>{
    const { project: project, permissionInfo: permissionInfo, isAgent: isAgent, hasCustomerChannels: hasCustomerChannels, knowledgeBaseInfo: knowledgeBaseInfo, raiseRequestInfo: raiseRequestInfo, opsGenieInfo: opsGenieInfo, boardInfo: boardInfo, calendarInfo: calendarInfo, hasNotificationLogs: hasNotificationLogs = true, hasHelpCenterSettings: hasHelpCenterSettings = false } = navData;
    const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = permissionInfo;
    const { isOnCallEnabled: isOnCallEnabled, isAlertEnabled: isAlertEnabled, opsGenieBaseUrl: opsGenieBaseUrl } = opsGenieInfo;
    const isProjectOrJiraAdmin = isAdmin || projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    const { portalUrl: portalUrl } = raiseRequestInfo;
    return {
        hasQueues: isAgent,
        hasCustomers: isAgent,
        hasCustomerChannels: hasCustomerChannels,
        hasReports: isAgent,
        hasPIN: !isAgent,
        hasShortcutsAdd: isProjectOrJiraAdmin,
        hasSettings: isProjectOrJiraAdmin,
        knowledge: {
            enabled: knowledgeBaseInfo.enabled,
            type: knowledgeBaseInfo.enabled ? knowledgeBaseInfo.knowledgeBaseType : null
        },
        raiseRequest: {
            enabled: raiseRequestInfo.enabled,
            url: raiseRequestInfo.enabled ? portalUrl : ''
        },
        opsgenieAlert: {
            enabled: isAlertEnabled,
            url: isAlertEnabled ? `${opsGenieBaseUrl}/alert/list` : ''
        },
        opsgenieOnCall: {
            enabled: isOnCallEnabled,
            url: isOnCallEnabled ? `${opsGenieBaseUrl}/schedule/whoIsOnCall` : ''
        },
        jsmBoard: {
            enabled: boardInfo.enabled,
            url: `/jira/servicedesk/projects/${project.key}/boards/${boardInfo.board.id}`
        },
        ...((0, $co1wz.ff)('jsm-calendar-view_bplvu') || (0, $co1wz.ff)('jsm-calendar-ga_81o9m')) && {
            jsmCalendar: {
                enabled: calendarInfo?.enabled ?? false,
                url: (0, $co1wz.ff)('jsm-calendar-ga_81o9m') ? `/jira/servicedesk/projects/${project.key}/boards/${boardInfo.board.id}/calendar` : `/jira/servicedesk/projects/${project.key}/calendar`
            }
        },
        hasNotificationLogs: (0, $4R6GH.fg)('jcs_master_flag') ? hasNotificationLogs : true,
        hasHelpCenterSettings: (0, $4R6GH.fg)('jcs_master_flag') ? isProjectOrJiraAdmin && hasHelpCenterSettings : false
    };
};
const $d21447ab73114105$export$86f3b0e5fff6482e = (data)=>({
        hasWorkload: true,
        hasSatisfaction: data.hasSatisfactionReport,
        hasRequestsDeflected: data.hasRequestsDeflectedReport,
        hasRequestsResolved: data.hasRequestsResolvedReport,
        hasNewReport: data.hasNewReport,
        hasManageReport: false
    });
const $d21447ab73114105$export$a1d86e289d0f43b7 = (navData, { hasActiveSoftwareAccess: hasActiveSoftwareAccess, environment: environment })=>{
    const { permissionInfo: permissionInfo, settingsInfo: settingsInfo } = navData;
    const { hasChangeManagement: hasChangeManagement = false, hasAddonInstaller: hasAddonInstaller = false, hasIncidentManagement: hasIncidentManagement = false, hasExternalLinks: hasExternalLinks = false, hasProjectAutomation: hasProjectAutomation = false, hasWidgetAddon: hasWidgetAddon = false, hasChat: hasChat = true, hasServices: hasServices = false, hasVersions: hasVersions = true, hasComponents: hasComponents = true, hasCustomerSupportManagement: hasCustomerSupportManagement = false, hasProductsAndEntitlements: hasProductsAndEntitlements = false, hasDeveloperEscalation: hasDeveloperEscalation = false, hasEmailRequest: hasEmailRequest = true, hasCSAT: hasCSAT = true, hasVirtualAgent: hasVirtualAgent = true, hasLanguageSupport: hasLanguageSupport = true, hasRequestTypes: hasRequestTypes = true, hasPortalSettings: hasPortalSettings = true, hasCustomerNotifications: hasCustomerNotifications = true, hasCustomerPermissions: hasCustomerPermissions = true, hasForms: hasForms = true, hasKnowledgeBase: hasKnowledgeBase = true } = settingsInfo;
    const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = permissionInfo;
    const isProjectAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    const isProjectOrJiraAdmin = isAdmin || isProjectAdmin;
    const hasIssueLayoutPermissions = permissionInfo.projectPermissionsQueried.EDIT_ISSUE_LAYOUT === true;
    return {
        hasDetails: isProjectOrJiraAdmin,
        hasPeople: isProjectOrJiraAdmin,
        hasSummary: true,
        hasIssueLayout: isProjectOrJiraAdmin || hasIssueLayoutPermissions,
        hasIssueTypes: isProjectOrJiraAdmin,
        hasJsdChangeManagement: hasChangeManagement,
        hasRequestTypes: (0, $4R6GH.fg)('jcs_master_flag') ? hasRequestTypes : true,
        hasCustomerPermissions: (0, $4R6GH.fg)('jcs_master_flag') ? hasCustomerPermissions : true,
        hasPortalSettings: (0, $4R6GH.fg)('jcs_master_flag') ? hasPortalSettings : true,
        hasEmailRequests: hasEmailRequest,
        hasCustomerNotifications: (0, $4R6GH.fg)('jcs_master_flag') ? hasCustomerNotifications : true,
        hasAddonInstaller: hasAddonInstaller,
        hasWidgetAddon: hasWidgetAddon && environment === 'prod',
        hasWidgetAddonDev: hasWidgetAddon && environment !== 'prod',
        hasChat: hasChat,
        hasSatisfactionSettings: hasCSAT,
        hasKnowledgeBase: (0, $4R6GH.fg)('jcs_master_flag') ? hasKnowledgeBase : true,
        hasSla: true,
        hasLegacyJSMAutomation: true,
        hasJsdAppDiscovery: true,
        hasJsdIncidentManagement: hasIncidentManagement,
        hasWorkflows: true,
        hasVersions: hasVersions,
        hasComponents: hasComponents,
        hasPermissions: true,
        hasIssueSecurity: true,
        hasNotifications: true,
        hasIssueCollectors: true,
        hasProjectAutomation: hasProjectAutomation,
        hasDevtools: hasActiveSoftwareAccess && isProjectAdmin,
        hasExternalLinks: hasExternalLinks,
        hasServices: hasServices,
        hasCustomerSupportManagement: hasCustomerSupportManagement,
        hasProductsAndEntitlements: hasProductsAndEntitlements,
        hasDeveloperEscalation: hasDeveloperEscalation,
        hasVirtualAgent: (0, $4R6GH.fg)('jcs_master_flag') ? hasVirtualAgent : true,
        hasLanguageSupport: (0, $4R6GH.fg)('jcs_master_flag') ? hasLanguageSupport : true,
        hasForms: (0, $4R6GH.fg)('jcs_master_flag') ? hasForms : true
    };
};
const $d21447ab73114105$export$d334c13580163a89 = (navData)=>({
        hasExternalLinks: navData?.settingsInfo?.hasExternalLinks,
        hasSatisfactionSettings: navData?.settingsInfo?.hasCSAT,
        hasEmailRequests: navData?.settingsInfo?.hasEmailRequest,
        hasChat: navData?.settingsInfo?.hasChat
    });

});


parcelRegister("gq0sA", function(module, exports) {

$parcel$export(module.exports, "usePageContext", () => $2299d7a4f1092420$export$9c25024bdfe755f7);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $dxCvy = parcelRequire("dxCvy");

var $9OXo1 = parcelRequire("9OXo1");

var $dFOAR = parcelRequire("dFOAR");
const $2299d7a4f1092420$var$getProjectContextResource = ()=>(0, $dxCvy.projectContextResourceWithCache);
const $2299d7a4f1092420$export$9c25024bdfe755f7 = (customContext)=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, $324W5.useResourceWithCustomRouterContext)($2299d7a4f1092420$var$getProjectContextResource(), customContext);
    const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, $dFOAR.useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
    const pageContextData = (0, $5uXOq.useMemo)(()=>({
            data: projectContext && serviceDeskContext ? {
                serviceDeskContext: {
                    portalId: serviceDeskContext.portalId,
                    portalUrl: serviceDeskContext.portalUrl,
                    canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                    userRole: serviceDeskContext.userRole,
                    serviceDeskId: serviceDeskContext.serviceDeskId
                },
                projectContext: {
                    projectId: projectContext.projectId,
                    projectKey: projectContext.projectKey,
                    projectName: projectContext.projectName,
                    projectType: projectContext.projectType,
                    // Refactor this in https://jdog.jira-dev.com/browse/JSK-443 this is a temporary fix to
                    // resolve a regression https://jira.atlassian.com/browse/JSDCLOUD-8751
                    isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                    isProjectSimplified: projectContext.simplified
                },
                tenantContext: {
                    baseUrl: tenantContext.baseUrl,
                    locale: tenantContext.locale,
                    userFullname: tenantContext.userFullname,
                    cloudId: tenantContext.cloudId,
                    fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                    atlassianAccountId: tenantContext.atlassianAccountId,
                    isJiraAdmin: tenantContext.isAdmin,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    activationId: tenantContext.activationId
                }
            } : null,
            loading: projectContextLoading || serviceDeskLoading,
            error: serviceDeskError || projectContextError || null
        }), [
        tenantContext,
        projectContext,
        serviceDeskContext,
        projectContextLoading,
        serviceDeskLoading,
        serviceDeskError,
        projectContextError
    ]);
    return [
        pageContextData
    ];
};

});
parcelRegister("dFOAR", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskContext", () => $6c09349e97fba749$export$712ead87353ac687);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $cAofY = parcelRequire("cAofY");
const $6c09349e97fba749$var$getServiceDeskContextResource = ()=>(0, $cAofY.serviceDeskContextResource);
const $6c09349e97fba749$export$712ead87353ac687 = (projectKey, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $324W5.useResourceWithCustomRouterContext)($6c09349e97fba749$var$getServiceDeskContextResource(), customContext);
    (0, $5uXOq.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};

});


parcelRegister("jLOUq", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcf67f44913f9c86$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $jD5no = parcelRequire("jD5no");

var $81ps3 = parcelRequire("81ps3");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $9noxX = parcelRequire("9noxX");

var $aLLc7 = parcelRequire("aLLc7");

var $cf7yQ = parcelRequire("cf7yQ");

var $e33py = parcelRequire("e33py");

var $8pMQX = parcelRequire("8pMQX");

var $gq0sA = parcelRequire("gq0sA");

var $4S0uJ = parcelRequire("4S0uJ");

var $cz40O = parcelRequire("cz40O");

var $8ubVf = parcelRequire("8ubVf");

var $dIdda = parcelRequire("dIdda");

var $1BIUA = parcelRequire("1BIUA");

var $cHb7s = parcelRequire("cHb7s");

var $gMO5K = parcelRequire("gMO5K");
const $bcf67f44913f9c86$var$ReportsAppBase = ({ appName: appName, pageId: pageId, pageTitle: pageTitle, children: children, AppBase: AppBase, ErrorView: ErrorView, PageStyle: PageStyle, actions: actions, dontShowHeader: dontShowHeader = false })=>{
    const [{ match: match }] = (0, $dIdda.useRouter)();
    const [{ data: pageContextData, error: error }] = (0, $gq0sA.usePageContext)();
    const { tenantContext: tenantContext, projectContext: projectContext, serviceDeskContext: serviceDeskContext } = pageContextData || {};
    const { projectKey: projectKey, projectName: projectName } = projectContext || {};
    const { baseUrl: baseUrl } = tenantContext || {};
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const pageContextProps = (0, $5uXOq.useMemo)(()=>({
            ...tenantContext,
            ...projectContext,
            ...serviceDeskContext
        }), [
        projectContext,
        serviceDeskContext,
        tenantContext
    ]);
    const breadcrumbs = [
        {
            href: '/jira/projects',
            text: formatMessage((0, $gMO5K.default).projectsBreadcrumb)
        },
        {
            href: (0, $81ps3.createProjectUrl)(projectKey || ''),
            text: projectName || ''
        },
        {
            href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/reports`,
            text: formatMessage((0, $gMO5K.default).reportsBreadcrumb)
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cz40O.SpaPageWrapper), {
        pageId: pageId,
        baseUrl: baseUrl,
        currentUrl: match.url,
        // @ts-expect-error - TS2322 - Type '{ projectId: number; projectKey: string; projectName: string; projectType: ProjectType; isAdmin: boolean; isProjectSimplified: boolean; } | undefined' is not assignable to type 'ProjectContext | null | undefined'.
        projectContext: projectContext,
        isLoading: !pageContextData && !error,
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e33py.ServiceDeskDocumentTitle), {
        projectName: projectName,
        section: "reports"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AppBase, {
        id: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9noxX.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aLLc7.ServiceDeskErrorBoundary), {
        appName: appName,
        ErrorView: ErrorView
    }, !dontShowHeader && ((0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8ubVf.Header), {
        title: pageTitle ? formatMessage(pageTitle) : '',
        breadcrumbs: breadcrumbs,
        actions: actions
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $bcf67f44913f9c86$var$HeaderContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(PageStyle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cHb7s.default), {
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1BIUA.default), {
            // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
            baseUrl: baseUrl,
            // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
            projectKey: projectKey,
            // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
            projectName: projectName
        }),
        title: pageTitle,
        actions: actions
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(PageStyle, null, children({
        pageContext: pageContextProps
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cf7yQ.JsdGettingStartedPanelShouldRender), null));
};
const $bcf67f44913f9c86$var$HeaderContainer = (0, $jJ1Sb.xcss)({
    paddingBottom: 'space.200'
});
$bcf67f44913f9c86$var$ReportsAppBase.defaultProps = {
    AppBase: (0, $jD5no.default),
    ErrorView: (0, $8pMQX.GenericError),
    PageStyle: (0, $4S0uJ.PageStyle)
};
var $bcf67f44913f9c86$export$2e2bcd8739ae039 = $bcf67f44913f9c86$var$ReportsAppBase;

});
parcelRegister("aLLc7", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskErrorBoundary", () => $8803d19bf51a79cd$export$d999c9325a45f4cf);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $e9YVH = parcelRequire("e9YVH");
/**
 * @deprecated GasV2 has been cleaned up, and it has not been logging any events since July. Please replace implementation with sending GasV3 analytics: go/gasv3
 */ const $8803d19bf51a79cd$var$triggerAnalyticsEvent = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
const $8803d19bf51a79cd$var$toErrorOrUndefined = (error)=>{
    if (error instanceof Error) return error;
    if (typeof error === 'string') return new Error(error);
    return undefined;
};
class $8803d19bf51a79cd$export$d999c9325a45f4cf extends (0, $5uXOq.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
        this.triggerEvent = $8803d19bf51a79cd$var$triggerAnalyticsEvent(`${props.appName}`);
    }
    componentDidCatch(error) {
        const { onErrorHandler: onErrorHandler, ErrorView: ErrorView, appName: appName } = this.props;
        const data = error instanceof Error ? {
            message: error.message,
            stack: error.stack
        } : {
            message: error
        };
        this.triggerEvent('error-boundary.error-caught', data);
        (0, $jcw0u.default)({
            meta: {
                id: 'unhandled',
                packageName: (0, $e9YVH.toPackageName)(appName) || 'jiraServicedeskCommon'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            event: this.triggerEvent,
            error: $8803d19bf51a79cd$var$toErrorOrUndefined(error),
            sendToPrivacyUnsafeSplunk: true
        });
        // If error view is present then allow error view to handle errors.
        if (ErrorView) return;
        // Some of the non spa apps uses this call back function which doesn't have any error view
        if (onErrorHandler) onErrorHandler(error);
        else // Rethrow for error boundary handling by app-base
        throw error;
    }
    render() {
        const { hasError: hasError } = this.state;
        const { ErrorView: ErrorView, children: children } = this.props;
        if (hasError && ErrorView) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ErrorView, null);
        return children;
    }
}

});

parcelRegister("cf7yQ", function(module, exports) {

$parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", () => $8aa55ef5824c4e4d$export$46976e0f90edfcfe);
$parcel$export(module.exports, "JsdGettingStartedPanel", () => $8aa55ef5824c4e4d$export$6f9913539cfb4ab6);
$parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", () => $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad);
$parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", () => $8aa55ef5824c4e4d$export$c7732c55900cf0b9);

var $5uXOq = parcelRequire("5uXOq");

var $hPtZI = parcelRequire("hPtZI");

var $lfTZh = parcelRequire("lfTZh");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender = (0, $hPtZI.lazyAfterPaint)(()=>(parcelRequire("6MoH3")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanel = (0, $hPtZI.lazyAfterPaint)(()=>(parcelRequire("ejgPJ")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton = (0, $hPtZI.lazyAfterPaint)(()=>(parcelRequire("2VzMc")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight = (0, $hPtZI.lazyAfterPaint)(()=>(parcelRequire("ahFso")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
});
const $8aa55ef5824c4e4d$export$46976e0f90edfcfe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-should-render",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender, null));
$8aa55ef5824c4e4d$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
const $8aa55ef5824c4e4d$export$6f9913539cfb4ab6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanel, null));
$8aa55ef5824c4e4d$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
const $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-open-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton, null));
$8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
const $8aa55ef5824c4e4d$export$c7732c55900cf0b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-reopen-spotlight",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight, null));
$8aa55ef5824c4e4d$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';

});
parcelRegister("6MoH3", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("chQyv").then(()=>parcelRequire('hZyYK'));

});

parcelRegister("ejgPJ", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("3Xgpx")
]).then(()=>parcelRequire('2NciN'));

});

parcelRegister("2VzMc", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("hlGg7")
]).then(()=>parcelRequire('4F6ZA'));

});

parcelRegister("ahFso", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("eXDqW")
]).then(()=>parcelRequire('6Wput'));

});


parcelRegister("e33py", function(module, exports) {

$parcel$export(module.exports, "PageTitle", () => $ae40b537a934bf9c$export$155581e8dc02007a);
$parcel$export(module.exports, "ServiceDeskDocumentTitle", () => $ae40b537a934bf9c$export$c7841d2c1c13065e);

var $5uXOq = parcelRequire("5uXOq");

var $9sGI6 = parcelRequire("9sGI6");

var $ew1Lk = parcelRequire("ew1Lk");

var $koVbs = parcelRequire("koVbs");

var $2BHCj = parcelRequire("2BHCj");
const $ae40b537a934bf9c$export$155581e8dc02007a = (props)=>{
    const { DocumentTitle: DocumentTitle, section: section, projectName: projectName, subsection: subsection } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const title = subsection ? // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $2BHCj.default)[section])} - ${subsection} - ${formatMessage((0, $2BHCj.default).serviceProject)}` : // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $2BHCj.default)[section])} - ${formatMessage((0, $2BHCj.default).serviceProject)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DocumentTitle, {
        title: title
    });
};
const $ae40b537a934bf9c$export$c7841d2c1c13065e = (0, $9sGI6.default)($ae40b537a934bf9c$export$155581e8dc02007a, {
    DocumentTitle: (0, $ew1Lk.DocumentTitle)
});
var $ae40b537a934bf9c$export$2e2bcd8739ae039 = $ae40b537a934bf9c$export$c7841d2c1c13065e;

});
parcelRegister("ew1Lk", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $41b549fa18234081$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $6nkVm = parcelRequire("6nkVm");

class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $6nkVm.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6nkVm.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("2BHCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d7eb5ce3479323e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7d7eb5ce3479323e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    atlassianAnalytics: {
        "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
        "defaultMessage": "Atlassian Analytics"
    },
    serviceProject: {
        "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
        "defaultMessage": "Service project"
    },
    knowledge: {
        "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
        "defaultMessage": "Knowledge base"
    },
    itsmFeatures: {
        "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
        "defaultMessage": "Features"
    },
    queues: {
        "id": "servicedesk-spa-commons.common.utils.document-title.queues",
        "defaultMessage": "Queues"
    },
    customers: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customers",
        "defaultMessage": "Customers"
    },
    organizations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
        "defaultMessage": "Organizations"
    },
    customerServiceEscalations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
        "defaultMessage": "Developer escalations"
    },
    reports: {
        "id": "servicedesk-spa-commons.common.utils.document-title.reports",
        "defaultMessage": "Reports"
    },
    services: {
        "id": "servicedesk-spa-commons.common.utils.document-title.services",
        "defaultMessage": "Services"
    },
    oncall: {
        "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
        "defaultMessage": "On-call"
    },
    email: {
        "id": "servicedesk-spa-commons.common.utils.document-title.email",
        "defaultMessage": "Email request"
    },
    sla: {
        "id": "servicedesk-spa-commons.common.utils.document-title.sla",
        "defaultMessage": "Service level agreements"
    },
    csat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.csat",
        "defaultMessage": "Customer satisfaction"
    },
    details: {
        "id": "servicedesk-spa-commons.common.utils.document-title.details",
        "defaultMessage": "Details"
    },
    portal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal",
        "defaultMessage": "Customer portal"
    },
    externalLinks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
        "defaultMessage": "Links"
    },
    portalSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
        "defaultMessage": "Portal settings"
    },
    automation: {
        "id": "servicedesk-spa-commons.common.utils.document-title.automation",
        "defaultMessage": "Automation"
    },
    advanced: {
        "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
        "defaultMessage": "Advanced"
    },
    languageSupport: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
        "defaultMessage": "Language support"
    },
    languageTranslations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
        "defaultMessage": "Language translations"
    },
    notificationEmail: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
        "defaultMessage": "Notification email"
    },
    notifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
        "defaultMessage": "Notifications"
    },
    internalNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
        "defaultMessage": "Internal notifications"
    },
    customerNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
        "defaultMessage": "Customer notifications"
    },
    widget: {
        "id": "servicedesk-spa-commons.common.utils.document-title.widget",
        "defaultMessage": "Widget"
    },
    customerPermissions: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
        "defaultMessage": "Customer permissions"
    },
    people: {
        "id": "servicedesk-spa-commons.common.utils.document-title.people",
        "defaultMessage": "Internal access"
    },
    issueType: {
        "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
        "defaultMessage": "Request types"
    },
    connectAppControls: {
        "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
        "defaultMessage": "Apps"
    },
    features: {
        "id": "servicedesk-spa-commons.common.utils.document-title.features",
        "defaultMessage": "Features"
    },
    calendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
        "defaultMessage": "Calendar"
    },
    projectSummary: {
        "id": "servicedesk-spa-commons.common.utils.document-title.project-summary.non-final",
        "defaultMessage": "Summary"
    },
    changeCalendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
        "defaultMessage": "Change calendar"
    },
    changeManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
        "defaultMessage": "Change management"
    },
    incidentManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
        "defaultMessage": "Incident management"
    },
    virtualAgentConversations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
        "defaultMessage": "Conversations"
    },
    virtualAgentIntents: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
        "defaultMessage": "Intents"
    },
    virtualAgentStandardFlows: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
        "defaultMessage": "Standard flows"
    },
    virtualAgentSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
        "defaultMessage": "Settings"
    },
    virtualAgentLanding: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
        "defaultMessage": "Virtual agent"
    },
    chat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.chat",
        "defaultMessage": "Chat"
    },
    proformaForms: {
        "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
        "defaultMessage": "Forms"
    },
    playbooks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.playbooks-non-final",
        "defaultMessage": "Playbooks"
    },
    dataClassifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
        "defaultMessage": "Data classification"
    },
    // EAX-256 - Finalise this string
    fieldsNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
        "defaultMessage": "Fields"
    },
    workflowScheme: {
        "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
        "defaultMessage": "Workflows"
    },
    journeysNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journeys-non-final",
        "defaultMessage": "Journeys"
    },
    journeyConfigNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journey-config-non-final",
        "defaultMessage": "Journey configuration"
    }
});

});


parcelRegister("8pMQX", function(module, exports) {

$parcel$export(module.exports, "ProjectNotFound", () => $951f6bd200bf8b89$export$849d319c342682a2);
$parcel$export(module.exports, "GenericError", () => $951f6bd200bf8b89$export$7d465be8efa67280);

var $5uXOq = parcelRequire("5uXOq");

var $4hGw3 = parcelRequire("4hGw3");

var $ew1Lk = parcelRequire("ew1Lk");

var $bTyOW = parcelRequire("bTyOW");

var $fC09Q = parcelRequire("fC09Q");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $dIdda = parcelRequire("dIdda");

var $4AdE6 = parcelRequire("4AdE6");
const $951f6bd200bf8b89$export$849d319c342682a2 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const projectsPath = '/jira/projects';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ew1Lk.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).notFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hGw3.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $fC09Q.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).notFoundTitle),
        description: formatMessage((0, $4AdE6.default).notFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), {
            to: projectsPath
        }, formatMessage((0, $4AdE6.default).notFoundAction))
    }));
};
const $951f6bd200bf8b89$export$7d465be8efa67280 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ew1Lk.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).genericDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hGw3.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $bTyOW.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).genericErrorTitle),
        description: formatMessage((0, $4AdE6.default).genericErrorDescription)
    }));
};

});
parcelRegister("bTyOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5073396748f92b4e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $5073396748f92b4e$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("5I4tL")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("h8kvT")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $dCLgq = parcelRequire("dCLgq");

var $h8kvT = parcelRequire("h8kvT");

var $5I4tL = parcelRequire("5I4tL");
const $5073396748f92b4e$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5I4tL)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($h8kvT))
});
var $5073396748f92b4e$export$2e2bcd8739ae039 = $5073396748f92b4e$var$Illustration;
// for advanced use only
const $5073396748f92b4e$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("h8kvT", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("5I4tL", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("fC09Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb376757c4acc5ab$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 53grvvhrxck68z6q4s7ztq4p
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/53grvvhrxck68z6q4s7ztq4p

var $dCLgq = parcelRequire("dCLgq");

var $3pGSh = parcelRequire("3pGSh");
const $bb376757c4acc5ab$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3pGSh)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($3pGSh))
});
var $bb376757c4acc5ab$export$2e2bcd8739ae039 = $bb376757c4acc5ab$var$Illustration;
// for advanced use only
const $bb376757c4acc5ab$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    226
];

});
parcelRegister("3pGSh", function(module, exports) {
module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();

});


parcelRegister("4AdE6", function(module, exports) {

$parcel$export(module.exports, "default", () => $135a9e70a6f11b3e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $135a9e70a6f11b3e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
        "defaultMessage": "Project not found - Service project"
    },
    notFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
        "defaultMessage": "This project isn't available"
    },
    notFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    notFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
        "defaultMessage": "View a list of all projects"
    },
    genericDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
        "defaultMessage": "Error - Service project"
    },
    genericErrorTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
        "defaultMessage": "An error occurred"
    },
    genericErrorDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
        "defaultMessage": "An error occurred while loading this page"
    }
});

});


parcelRegister("4S0uJ", function(module, exports) {

$parcel$export(module.exports, "PageStyle", () => $7307247c9fc02c84$export$c59987a647e9a55);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aHqrR = parcelRequire("aHqrR");
const $7307247c9fc02c84$export$c59987a647e9a55 = ({ Page: Page, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7307247c9fc02c84$var$JSDSpaPageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Page, null, children));
$7307247c9fc02c84$export$c59987a647e9a55.defaultProps = {
    Page: (0, $aHqrR.default)
};
var $7307247c9fc02c84$export$2e2bcd8739ae039 = $7307247c9fc02c84$export$c59987a647e9a55;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7307247c9fc02c84$var$JSDSpaPageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s8zdiv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aHqrR", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa66aa050f59c1b8$export$2e2bcd8739ae039);

var $7mDUF = parcelRequire("7mDUF");

var $8bHfj = parcelRequire("8bHfj");

var $jMaea = parcelRequire("jMaea");
var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$fa66aa050f59c1b8$export$2e2bcd8739ae039 = (0, $7mDUF.default);

});
parcelRegister("7mDUF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6282b4eef5766075$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $11b0c = parcelRequire("11b0c");
function $6282b4eef5766075$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6282b4eef5766075$var$bannerStyles = {
    name: "4oew4k",
    styles: "width:100%;position:fixed"
};
const $6282b4eef5766075$var$bannerContainerStyles = {
    name: "1x3pv69",
    styles: "width:100%;position:relative;z-index:3;flex:1 0 auto;transition:height 0.25s ease-in-out"
};
const $6282b4eef5766075$var$pageContentStyles = {
    name: "15n167b",
    styles: "min-width:0;position:relative;z-index:1;flex:1 1 auto"
};
const $6282b4eef5766075$var$wrapperStyles = {
    name: "m5v4sl",
    styles: "display:flex;width:100%;min-height:100%;flex-direction:column"
};
const $6282b4eef5766075$var$mainContainerStyles = {
    name: "1cete8c",
    styles: "display:flex;flex:1 1 auto"
};
const $6282b4eef5766075$var$navigationStyles = {
    name: "wrqbg1",
    styles: "position:relative;z-index:2"
};
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $6282b4eef5766075$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, $11b0c.defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6282b4eef5766075$var$wrapperStyles,
        "data-testid": testId
    }, banner ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6282b4eef5766075$var$bannerContainerStyles,
        style: {
            height: isBannerOpen ? `${bannerHeight}px` : '0'
        },
        "aria-hidden": !isBannerOpen,
        "data-testid": testId ? `${testId}--banner-container` : undefined
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6282b4eef5766075$var$bannerStyles
    }, banner)) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6282b4eef5766075$var$mainContainerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6282b4eef5766075$var$navigationStyles
    }, navigation), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6282b4eef5766075$var$pageContentStyles
    }, children)));
};
var $6282b4eef5766075$export$2e2bcd8739ae039 = $6282b4eef5766075$var$Page;

});
parcelRegister("11b0c", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $f44176f7e15183a6$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $f44176f7e15183a6$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $f44176f7e15183a6$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $f44176f7e15183a6$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $f44176f7e15183a6$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $f44176f7e15183a6$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $f44176f7e15183a6$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $f44176f7e15183a6$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $f44176f7e15183a6$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $f44176f7e15183a6$export$936829b4511db3e4);
const $f44176f7e15183a6$export$3aaf3a78c909ea56 = 8;
const $f44176f7e15183a6$export$74797698e12f8baa = 12;
const $f44176f7e15183a6$export$b8241a1616ab1b96 = $f44176f7e15183a6$export$3aaf3a78c909ea56 * 10;
const $f44176f7e15183a6$export$2a89a65a43bab52d = {
    comfortable: $f44176f7e15183a6$export$3aaf3a78c909ea56 * 5,
    cosy: $f44176f7e15183a6$export$3aaf3a78c909ea56 * 2,
    compact: $f44176f7e15183a6$export$3aaf3a78c909ea56 * 0.5
};
const $f44176f7e15183a6$export$8ec7372efd74b753 = 'cosy';
const $f44176f7e15183a6$export$d77f83c3d17a7b8a = 52;
const $f44176f7e15183a6$export$f8725d21f81f3e01 = 0;
const $f44176f7e15183a6$export$2303d2bd9eeff99a = 'fixed';
const $f44176f7e15183a6$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $f44176f7e15183a6$export$8b7e31f391e6e681 = '--ds-column-span';
const $f44176f7e15183a6$export$936829b4511db3e4 = '--ds-grid-spacing';

});


parcelRegister("8bHfj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dcf7cd802acc3dc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $11b0c = parcelRequire("11b0c");

var $ivppf = parcelRequire("ivppf");

var $jMaea = parcelRequire("jMaea");

var $htEEQ = parcelRequire("htEEQ");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $8dcf7cd802acc3dc$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $5uXOq.useContext)((0, $htEEQ.GridContext));
    const { medium: medium } = (0, $5uXOq.useContext)((0, $jMaea.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $11b0c.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $11b0c.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htEEQ.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivppf.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $8dcf7cd802acc3dc$export$2e2bcd8739ae039 = $8dcf7cd802acc3dc$var$GridWrapper;

});
parcelRegister("ivppf", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $1cdfa0aca94d366d$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $11b0c = parcelRequire("11b0c");

var $htEEQ = parcelRequire("htEEQ");
function $1cdfa0aca94d366d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1cdfa0aca94d366d$var$gridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $11b0c.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $1cdfa0aca94d366d$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $11b0c.varColumnsNum)}) * ${(0, $11b0c.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $1cdfa0aca94d366d$var$nestedGridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $11b0c.varGridSpacing)}))`
});
const $1cdfa0aca94d366d$export$ef2184bd89960b14 = ({ layout: layout = (0, $11b0c.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $5uXOq.useContext)((0, $htEEQ.GridContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $1cdfa0aca94d366d$var$gridStyles,
            $1cdfa0aca94d366d$var$gridLayoutStyles[layout],
            isNested && $1cdfa0aca94d366d$var$nestedGridStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $11b0c.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $11b0c.varGridSpacing)]: `${(0, $11b0c.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("htEEQ", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $0003b8639fb07aed$export$11cae3e04ab99fae);

var $5uXOq = parcelRequire("5uXOq");

var $11b0c = parcelRequire("11b0c");
const $0003b8639fb07aed$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $11b0c.defaultSpacing),
    columns: (0, $11b0c.defaultGridColumns)
});

});


parcelRegister("jMaea", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $e8cfd28f42e3bb74$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $e8cfd28f42e3bb74$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $11b0c = parcelRequire("11b0c");

var $htEEQ = parcelRequire("htEEQ");
var $e8cfd28f42e3bb74$var$ColumnVariant;
/**
 * Determines the method by which column width is calculated.
 */ (function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
})($e8cfd28f42e3bb74$var$ColumnVariant || ($e8cfd28f42e3bb74$var$ColumnVariant = {}));
const $e8cfd28f42e3bb74$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $11b0c.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $e8cfd28f42e3bb74$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $e8cfd28f42e3bb74$var$singleColumnWidth = `(${$e8cfd28f42e3bb74$var$availableWidth} / var(${(0, $11b0c.varColumnsNum)}))`;
const $e8cfd28f42e3bb74$var$gridColumnStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$e8cfd28f42e3bb74$var$singleColumnWidth} - var(${(0, $11b0c.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $11b0c.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $e8cfd28f42e3bb74$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $11b0c.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$e8cfd28f42e3bb74$var$singleColumnWidth} *  var(${(0, $11b0c.varColumnSpan)}) - var(${(0, $11b0c.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $11b0c.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $e8cfd28f42e3bb74$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    medium: (0, $11b0c.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $e8cfd28f42e3bb74$var$GridColumn = ({ medium: medium = (0, $11b0c.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $5uXOq.useContext)((0, $htEEQ.GridContext));
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $e8cfd28f42e3bb74$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($e8cfd28f42e3bb74$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $e8cfd28f42e3bb74$var$gridColumnStyles,
            $e8cfd28f42e3bb74$var$gridColumnWidthStyles[variant]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $11b0c.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $e8cfd28f42e3bb74$export$2e2bcd8739ae039 = $e8cfd28f42e3bb74$var$GridColumn;

});




parcelRegister("cz40O", function(module, exports) {

$parcel$export(module.exports, "SpaPageWrapper", () => $2099b56eb86565d0$export$577514961fbf4842);
// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $dJl1T = parcelRequire("dJl1T");

var $9sGI6 = parcelRequire("9sGI6");

var $9dbF6 = parcelRequire("9dbF6");

var $9NiTW = parcelRequire("9NiTW");

var $cYaqS = parcelRequire("cYaqS");

var $8pMQX = parcelRequire("8pMQX");
const $2099b56eb86565d0$export$91f88695e0d311a5 = (props)=>{
    const { projectContext: projectContext, isLoading: isLoading, error: error, children: children, AccessCheck: AccessCheck, AuthenticationCheck: AuthenticationCheck, ProjectNotFound: ProjectNotFound, GenericError: GenericError, SubProductUpdater: SubProductUpdater } = props;
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null);
    if (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('jsdspa-page-wrapper', 'rendering-error-page', error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AuthenticationCheck, null, error.statusCode === 404 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProjectNotFound, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(GenericError, null));
    }
    if (projectContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SubProductUpdater, {
        subProduct: "serviceDesk"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AuthenticationCheck, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AccessCheck, null, children)));
    return null;
};
const $2099b56eb86565d0$export$577514961fbf4842 = (0, $9sGI6.default)($2099b56eb86565d0$export$91f88695e0d311a5, {
    AccessCheck: (0, $cYaqS.default),
    GenericError: (0, $8pMQX.GenericError),
    ProjectNotFound: (0, $8pMQX.ProjectNotFound),
    AuthenticationCheck: (0, $9NiTW.AuthenticationCheck),
    SubProductUpdater: (0, $9dbF6.SubProductUpdater)
});
var $2099b56eb86565d0$export$2e2bcd8739ae039 = $2099b56eb86565d0$export$577514961fbf4842;

});
parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $bNvU3 = parcelRequire("bNvU3");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bNvU3.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1u3Jv = parcelRequire("1u3Jv");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1u3Jv.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $dJl1T = parcelRequire("dJl1T");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $6BZYo.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $dJl1T.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $701d07b56c3e3574$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("cYaqS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f72fff5a1e4c8937$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");


var $4UFLs = parcelRequire("4UFLs");

var $g3A84 = parcelRequire("g3A84");
const $f72fff5a1e4c8937$var$AccessCheck = ({ children: children })=>{
    const isSettingsRoute = (0, $6jY6G.useCurrentRoute)().path.includes(`${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/:projectKey/settings/`);
    const Gate = isSettingsRoute ? (0, $g3A84.default) : (0, $4UFLs.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Gate, null, children);
};
var $f72fff5a1e4c8937$export$2e2bcd8739ae039 = $f72fff5a1e4c8937$var$AccessCheck;

});
const $7c914880cb332728$export$967ba7bfb5ce30bd = '/jira/servicedesk/projects';

parcelRegister("4UFLs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9befbeaff9f5385d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $daoB1 = parcelRequire("daoB1");

var $dIdda = parcelRequire("dIdda");

var $iDvG9 = parcelRequire("iDvG9");
const $9befbeaff9f5385d$var$ProductAccessCheck = ({ children: children })=>{
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $daoB1.useApplicationPermissions)();
    const [projectKey = ''] = (0, $dIdda.usePathParam)('projectKey');
    if (projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDvG9.default), null, children);
    return hasServiceDeskAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
        to: "/jira"
    });
};
var $9befbeaff9f5385d$export$2e2bcd8739ae039 = $9befbeaff9f5385d$var$ProductAccessCheck;

});
parcelRegister("iDvG9", function(module, exports) {

$parcel$export(module.exports, "default", () => $34dd3dc578b1a167$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dIdda = parcelRequire("dIdda");

var $dFOAR = parcelRequire("dFOAR");


var $fhAnU = parcelRequire("fhAnU");
const $34dd3dc578b1a167$var$AgentCheck = ({ children: children })=>{
    const [projectKey = ''] = (0, $dIdda.usePathParam)('projectKey');
    const [{ data: data, error: error }] = (0, $dFOAR.useServiceDeskContext)();
    if (data || error) {
        // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
        if (!(0, $fhAnU.isAccessError)(error)) {
            const { userRole: userRole = '' } = data || {};
            if (userRole === 'agent' || userRole === 'agent-project-admin') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
            if (error) throw error;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/${projectKey}/issues`
        });
    }
    return null;
};
var $34dd3dc578b1a167$export$2e2bcd8739ae039 = $34dd3dc578b1a167$var$AgentCheck;

});
parcelRegister("fhAnU", function(module, exports) {

$parcel$export(module.exports, "isAccessError", () => $1a790f4bb1355504$export$ddaebe4928e793cb);

const $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES = [
    (0, $3cd8a0ece36fbae5$export$a3269a3914b007e3),
    (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef),
    (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)
];
const $1a790f4bb1355504$export$ddaebe4928e793cb = (error)=>error?.statusCode != null ? $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES.includes(error.statusCode) : false;

});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;




parcelRegister("g3A84", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e7d6646168c089$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8pMQX = parcelRequire("8pMQX");

var $dFOAR = parcelRequire("dFOAR");

var $fhAnU = parcelRequire("fhAnU");
const $60e7d6646168c089$var$SettingsAccessCheck = ({ children: children })=>{
    const [{ data: serviceDeskContext, error: serviceDeskContextError }] = (0, $dFOAR.useServiceDeskContext)();
    const userRole = serviceDeskContext?.userRole;
    // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
    const hasAccessError = (0, $fhAnU.isAccessError)(serviceDeskContextError);
    // Service desk context is updated on every route change
    // If context fails to give us an indicative result (e.g. fetch failed, 500 error)
    // We will continue to use current value to assess permissions
    if (userRole === 'agent-project-admin' && !hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    if (userRole !== undefined || hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.ProjectNotFound), null);
    if (serviceDeskContextError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.GenericError), null);
    return null;
};
var $60e7d6646168c089$export$2e2bcd8739ae039 = $60e7d6646168c089$var$SettingsAccessCheck;

});



parcelRegister("8ubVf", function(module, exports) {

$parcel$export(module.exports, "Header", () => $0532a94f373aae43$export$8b251419efc915eb);

var $5uXOq = parcelRequire("5uXOq");

var $1eHCV = parcelRequire("1eHCV");
var $dkxUw = parcelRequire("dkxUw");

var $53KbV = parcelRequire("53KbV");

var $6T4rd = parcelRequire("6T4rd");
var $dsFR3 = parcelRequire("dsFR3");
var $iaTnv = parcelRequire("iaTnv");
var $jJ1Sb = parcelRequire("jJ1Sb");
const $0532a94f373aae43$var$headerContainerStyles = (0, $jJ1Sb.xcss)({
    marginTop: 'space.200',
    marginBottom: 'space.200',
    marginLeft: 'space.300',
    marginRight: 'space.300',
    gap: 'space.050'
});
const $0532a94f373aae43$var$headerBorder = (0, $jJ1Sb.xcss)({
    borderBottom: `1px solid ${"var(--ds-border, #091E4224)"}`
});
const $0532a94f373aae43$var$headerElementsSpace = (0, $jJ1Sb.xcss)({
    justifyContent: 'space-between',
    alignItems: 'end'
});
const $0532a94f373aae43$export$8b251419efc915eb = ({ title: title, breadcrumbs: breadcrumbs, actions: actions })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaTnv.default), {
        xcss: $0532a94f373aae43$var$headerBorder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaTnv.default), {
        xcss: $0532a94f373aae43$var$headerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaTnv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dkxUw.default), null, breadcrumbs.map((crumb)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eHCV.default), {
            href: crumb.href,
            text: crumb.text
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaTnv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), {
        xcss: $0532a94f373aae43$var$headerElementsSpace
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $53KbV.default), {
        size: "large"
    }, title), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), null, actions)))));
};

});

parcelRegister("1BIUA", function(module, exports) {

$parcel$export(module.exports, "default", () => $73c84489faf50721$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $e0Brz = parcelRequire("e0Brz");

var $jS4lj = parcelRequire("jS4lj");

var $c2D8L = parcelRequire("c2D8L");

var $gEFwt = parcelRequire("gEFwt");

var $koVbs = parcelRequire("koVbs");

var $kwX4O = parcelRequire("kwX4O");
const $73c84489faf50721$var$ProjectSettingsBreadcrumb = ({ baseUrl: baseUrl, projectKey: projectKey, projectName: projectName })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0Brz.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jS4lj.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectName: projectName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/reports`,
            text: formatMessage((0, $kwX4O.default).reportsBreadcrumbTitle),
            type: 'projectSettings'
        }
    })));
};
var $73c84489faf50721$export$2e2bcd8739ae039 = $73c84489faf50721$var$ProjectSettingsBreadcrumb;

});
parcelRegister("kwX4O", function(module, exports) {

$parcel$export(module.exports, "default", () => $0683f400a1ea0c3e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0683f400a1ea0c3e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    reportsBreadcrumbTitle: {
        "id": "spa-apps-servicedesk-reports-base.breadcrumb.reports-breadcrumb-title",
        "defaultMessage": "Reports"
    }
});

});


parcelRegister("cHb7s", function(module, exports) {

$parcel$export(module.exports, "default", () => $595a97230cddb61d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $53KbV = parcelRequire("53KbV");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $cS37j = parcelRequire("cS37j");

var $az4zD = parcelRequire("az4zD");
const $595a97230cddb61d$var$Header = ({ title: title, breadcrumbs: breadcrumbs, intl: { formatMessage: formatMessage }, actions: actions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        truncateTitle: true,
        breadcrumbs: breadcrumbs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $595a97230cddb61d$var$titleContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $53KbV.default), {
        level: "h700",
        as: "h1"
    }, title && formatMessage(title))), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), null, actions)));
var $595a97230cddb61d$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($595a97230cddb61d$var$Header);
const $595a97230cddb61d$var$titleContainer = (0, $jJ1Sb.xcss)({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end'
});

});
parcelRegister("cS37j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a15efb09f101ecb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1jYIE = parcelRequire("1jYIE");
const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1jYIE.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
    });
var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a15efb09f101ecb$var$ActionsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1jYIE", function(module, exports) {

$parcel$export(module.exports, "default", () => $622b85ee800d74dc$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $5uXOq = parcelRequire("5uXOq");

var $fIdIO = parcelRequire("fIdIO");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $622b85ee800d74dc$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fIdIO.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fIdIO.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fIdIO.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fIdIO.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fIdIO.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fIdIO.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $622b85ee800d74dc$export$2e2bcd8739ae039 = $622b85ee800d74dc$var$PageHeader;

});
parcelRegister("fIdIO", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $63eaf4260decdc00$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $63eaf4260decdc00$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $63eaf4260decdc00$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $63eaf4260decdc00$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $63eaf4260decdc00$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $63eaf4260decdc00$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");
function $63eaf4260decdc00$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $63eaf4260decdc00$var$truncateStyles = {
    name: "13oenf9",
    styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $63eaf4260decdc00$var$outerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $63eaf4260decdc00$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $63eaf4260decdc00$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $63eaf4260decdc00$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $63eaf4260decdc00$var$titleContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $63eaf4260decdc00$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $63eaf4260decdc00$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $63eaf4260decdc00$var$bottomBarStyles = (0, $jJ1Sb.xcss)({
    marginBlockStart: 'space.200'
});
const $63eaf4260decdc00$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $63eaf4260decdc00$var$outerStyles
    }, children);
};
const $63eaf4260decdc00$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("h1", {
        css: [
            $63eaf4260decdc00$var$titleStyles,
            truncateTitle && $63eaf4260decdc00$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $63eaf4260decdc00$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $63eaf4260decdc00$var$titleWrapperStyles,
            truncateTitle && $63eaf4260decdc00$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $63eaf4260decdc00$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $63eaf4260decdc00$var$titleContainerStyles,
            truncateTitle && $63eaf4260decdc00$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $63eaf4260decdc00$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $63eaf4260decdc00$var$actionStyles
    }, children);
};
const $63eaf4260decdc00$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6T4rd.default), {
        xcss: $63eaf4260decdc00$var$bottomBarStyles
    }, children);
};

});




parcelRegister("gMO5K", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6ceb509eee39709$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b6ceb509eee39709$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectsBreadcrumb: {
        "id": "spa-apps-servicedesk-reports-base.projects-breadcrumb",
        "defaultMessage": "Projects"
    },
    reportsBreadcrumb: {
        "id": "spa-apps-servicedesk-reports-base.reports-breadcrumb",
        "defaultMessage": "Reports"
    }
});

});


parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("4orJd", function(module, exports) {

$parcel$export(module.exports, "default", () => $9112a5390193bdd4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9112a5390193bdd4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    homePageTitle: {
        "id": "spa-apps-servicedesk-reports-home-page.home-page-title",
        "defaultMessage": "Reports"
    },
    newReportButton: {
        "id": "spa-apps-servicedesk-reports-home-page.new-report-button",
        "defaultMessage": "Create new report"
    }
});

});

parcelRegister("h7sEe", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ac59ebee0d86358$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4hGw3 = parcelRequire("4hGw3");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $9MjbF = parcelRequire("9MjbF");

var $koVbs = parcelRequire("koVbs");

var $y8WG5 = parcelRequire("y8WG5");

var $lO6m5 = parcelRequire("lO6m5");
var $7lnvH = parcelRequire("7lnvH");

var $k0laR = parcelRequire("k0laR");

var $6PXzk = parcelRequire("6PXzk");
const $6ac59ebee0d86358$var$HomePageSpa = ({ pageContext: pageContext })=>{
    const { projectKey: projectKey } = pageContext;
    const { reportsConfig: reportsConfig, loading: loading } = (0, $k0laR.useReportsHomePageController)(projectKey);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: features } = (0, $y8WG5.useFeatures)();
    const isEmpty = reportsConfig.reduce((accumulator, currentValue)=>accumulator && !currentValue.access, true);
    if (isEmpty && reportsConfig.length > 0 || !features?.hasReports) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hGw3.default), {
        header: formatMessage((0, $6PXzk.default).emptyStateHeader),
        description: formatMessage((0, $6PXzk.default).emptyStateDescription),
        headingLevel: 3,
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($lO6m5)))
    });
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $6ac59ebee0d86358$var$spinnerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9MjbF.default), {
        size: "large"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $6ac59ebee0d86358$var$filtersAndViewContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7lnvH.ReportsHomePage), {
        reportsConfig: reportsConfig,
        extraFilters: []
    }));
};
var $6ac59ebee0d86358$export$2e2bcd8739ae039 = $6ac59ebee0d86358$var$HomePageSpa;
const $6ac59ebee0d86358$var$filtersAndViewContainer = (0, $jJ1Sb.xcss)({
    display: 'flex',
    marginTop: 'space.600',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 'space.200'
});
const $6ac59ebee0d86358$var$spinnerContainer = (0, $jJ1Sb.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    marginTop: 'space.500'
});

});
parcelRegister("lO6m5", function(module, exports) {
module.exports = new URL("no-perms-empty-state.969408f9.svg", import.meta.url).toString();

});

parcelRegister("7lnvH", function(module, exports) {

$parcel$export(module.exports, "ReportsHomePage", () => $55fe31d18db90a44$export$1375e3d3ca1a8d02);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $f3JF7 = parcelRequire("f3JF7");

var $dHJL9 = parcelRequire("dHJL9");

var $4hGw3 = parcelRequire("4hGw3");

var $f9TfY = parcelRequire("f9TfY");

var $bMQf5 = parcelRequire("bMQf5");

var $dsFR3 = parcelRequire("dsFR3");
var $iaTnv = parcelRequire("iaTnv");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $lO6m5 = parcelRequire("lO6m5");
var $2hGgM = parcelRequire("2hGgM");


var $41QKo = parcelRequire("41QKo");

var $jgvSG = parcelRequire("jgvSG");

var $cbRTI = parcelRequire("cbRTI");

var $Ou5pt = parcelRequire("Ou5pt");
const $55fe31d18db90a44$var$searchContainer = (0, $jJ1Sb.xcss)({
    marginLeft: 'space.negative.250'
});
const $55fe31d18db90a44$var$filterStyles = (0, $jJ1Sb.xcss)({
    gap: 'space.050'
});
const $55fe31d18db90a44$var$filtersAndViewContainer = (0, $jJ1Sb.xcss)({
    justifyContent: 'space-between'
});
const $55fe31d18db90a44$var$extraFiltersContainer = (0, $jJ1Sb.xcss)({
    gap: 'space.150'
});
const $55fe31d18db90a44$export$1375e3d3ca1a8d02 = ({ reportsConfig: reportsConfig, extraFilters: extraFilters })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { searchForReport: searchForReport, searchValue: searchValue, filteredReportsConfig: filteredReportsConfig } = (0, $cbRTI.useReportsHomePageController)(reportsConfig);
    const [viewType, setViewType] = (0, $5uXOq.useState)((0, $ff7f6bf1045148f7$export$c5ccaba974d9b5b6));
    const switchViews = (0, $5uXOq.useCallback)(()=>{
        if (viewType === (0, $ff7f6bf1045148f7$export$9586318477fbfa73)) {
            setViewType((0, $ff7f6bf1045148f7$export$c5ccaba974d9b5b6));
            return;
        }
        setViewType((0, $ff7f6bf1045148f7$export$9586318477fbfa73));
    }, [
        setViewType,
        viewType
    ]);
    const noAccess = reportsConfig.reduce((accumulator, currentValue)=>accumulator && !currentValue.access, true);
    if (noAccess && reportsConfig.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hGw3.default), {
        header: formatMessage((0, $Ou5pt.messages).noAccessEmptyStateHeader),
        description: formatMessage((0, $Ou5pt.messages).noAccessEmptyStateDescription),
        headingLevel: 3,
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($lO6m5)))
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaTnv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), {
        xcss: $55fe31d18db90a44$var$filtersAndViewContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), {
        xcss: $55fe31d18db90a44$var$filterStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), {
        xcss: $55fe31d18db90a44$var$searchContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f3JF7.Search), {
        onClick: searchForReport,
        placeholder: formatMessage((0, $Ou5pt.messages).searchPlaceholder),
        tooltip: formatMessage((0, $Ou5pt.messages).searchPlaceholder),
        label: formatMessage((0, $Ou5pt.messages).searchPlaceholder),
        value: searchValue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), {
        xcss: $55fe31d18db90a44$var$extraFiltersContainer
    }, extraFilters.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), null, item)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHJL9.default), {
        onClick: switchViews,
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        iconAfter: viewType === (0, $ff7f6bf1045148f7$export$c5ccaba974d9b5b6) ? (0, (/*@__PURE__*/$parcel$interopDefault($f9TfY))) : (0, (/*@__PURE__*/$parcel$interopDefault($bMQf5)))
    }, viewType === (0, $ff7f6bf1045148f7$export$c5ccaba974d9b5b6) ? formatMessage((0, $Ou5pt.messages).swithcToListViewButton) : formatMessage((0, $Ou5pt.messages).swithcToCardViewButton)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaTnv.default), null, filteredReportsConfig.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, viewType === (0, $ff7f6bf1045148f7$export$c5ccaba974d9b5b6) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgvSG.ThumbnailView), {
        reportsConfig: filteredReportsConfig
    }), viewType === (0, $ff7f6bf1045148f7$export$9586318477fbfa73) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41QKo.ListView), {
        reportsConfig: filteredReportsConfig
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hGw3.default), {
        header: formatMessage((0, $Ou5pt.messages).searchEmptyStateTitle),
        description: formatMessage((0, $Ou5pt.messages).searchEmptyStateDescription),
        headingLevel: 3,
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($2hGgM)))
    })));
};

});
parcelRegister("f3JF7", function(module, exports) {

$parcel$export(module.exports, "Search", () => $0a8bc00a101322d8$export$4b85d3515bd863a5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dPuU1 = parcelRequire("dPuU1");


var $eGqCc = parcelRequire("eGqCc");

var $eLnMI = parcelRequire("eLnMI");

var $kvfLL = parcelRequire("kvfLL");
function $0a8bc00a101322d8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0a8bc00a101322d8$var$searchInputContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'relative',
    marginInlineEnd: "var(--ds-space-100, 8px)",
    marginInlineStart: "var(--ds-space-250, 20px)",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $ca0f2966c3a33e95$export$24ec62cee78b7042) - 1}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        display: 'none !important'
    }
});
const $0a8bc00a101322d8$var$searchInputIconStyles = {
    name: "e25v3a",
    styles: "width:20px;height:20px;position:absolute;inset-block-start:5px;inset-inline-start:10px;pointer-events:none"
};
const $0a8bc00a101322d8$var$newSearchBorderStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    border: `${"var(--ds-border-width, 1px)"} solid`,
    '&:focus': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} var(${(0, $ca0f2966c3a33e95$export$d8bde68ac946124f)})`
    }
});
const $0a8bc00a101322d8$var$searchInputStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    boxSizing: 'border-box',
    width: '220px',
    height: "var(--ds-space-400, 32px)",
    padding: `0 ${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-500, 40px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $ca0f2966c3a33e95$export$13f8aa8f663f4c99)})`,
    border: '2px solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderColor: `var(${(0, $ca0f2966c3a33e95$export$65f656ad520ea71)})`,
    borderRadius: "var(--ds-border-radius-200, 6px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $ca0f2966c3a33e95$export$d81606c1fc5119bc)})`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::placeholder': {
        color: 'inherit'
    },
    '&:focus': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderColor: `var(${(0, $ca0f2966c3a33e95$export$d8bde68ac946124f)})`
    },
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $ca0f2966c3a33e95$export$73e44f54603a0964)})`
    }
});
const $0a8bc00a101322d8$var$searchIconStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $ca0f2966c3a33e95$export$24ec62cee78b7042}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        display: 'none !important'
    }
});
const $0a8bc00a101322d8$var$SearchComponent = (props)=>{
    const { onClick: onClick, placeholder: placeholder, label: label, value: value } = props;
    const theme = (0, $eGqCc.useTheme)();
    const search = theme.mode.search;
    const onChange = (...args)=>{
        // @ts-expect-error
        onClick && onClick(...args);
    };
    const onInputClick = (...args)=>{
        // @ts-expect-error
        onClick && onClick(...args);
    };
    const searchInputDynamicStyles = (0, $eLnMI.stripEmptyProperties)({
        [(0, $ca0f2966c3a33e95$export$13f8aa8f663f4c99)]: search.default.backgroundColor,
        [(0, $ca0f2966c3a33e95$export$d81606c1fc5119bc)]: search.default.color,
        [(0, $ca0f2966c3a33e95$export$65f656ad520ea71)]: search.default.borderColor,
        [(0, $ca0f2966c3a33e95$export$d8bde68ac946124f)]: search.focus.borderColor,
        [(0, $ca0f2966c3a33e95$export$73e44f54603a0964)]: search.hover.backgroundColor
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $0a8bc00a101322d8$var$searchInputContainerStyles,
        role: "search"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $0a8bc00a101322d8$var$searchInputIconStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dPuU1))), {
        label: ""
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: searchInputDynamicStyles,
        css: [
            $0a8bc00a101322d8$var$searchInputStyles,
            $0a8bc00a101322d8$var$newSearchBorderStyles
        ],
        "aria-label": label,
        placeholder: placeholder,
        onChange: onChange,
        onClick: onInputClick,
        value: value
    }));
};
const $0a8bc00a101322d8$export$4b85d3515bd863a5 = (props)=>{
    const { placeholder: placeholder, tooltip: tooltip, label: label, value: value, ...iconButtonProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)($0a8bc00a101322d8$var$SearchComponent, {
        onClick: iconButtonProps.onClick,
        placeholder: placeholder,
        label: label,
        value: value || ''
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kvfLL.IconButton), {
        // @ts-ignore Overriding styles is not supported.
        css: $0a8bc00a101322d8$var$searchIconStyles,
        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dPuU1))), {
            label: label
        }),
        tooltip: tooltip,
        ...iconButtonProps
    }));
};
var $0a8bc00a101322d8$export$2e2bcd8739ae039 = $0a8bc00a101322d8$export$4b85d3515bd863a5;

});
const $ca0f2966c3a33e95$export$30fa7cc5f2690a43 = 56;
const $ca0f2966c3a33e95$export$4033a111ca79977d = 1280;
const $ca0f2966c3a33e95$export$24ec62cee78b7042 = 1130;
const $ca0f2966c3a33e95$export$d8bde68ac946124f = '--ds--ans--fbc';
const $ca0f2966c3a33e95$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $ca0f2966c3a33e95$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $ca0f2966c3a33e95$export$d81606c1fc5119bc = '--ds--ans--c';
const $ca0f2966c3a33e95$export$65f656ad520ea71 = '--ds--ans--bc';


parcelRegister("f9TfY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0928f15364e7bd2$var$_react = $b0928f15364e7bd2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");
function $b0928f15364e7bd2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b0928f15364e7bd2$var$ListIcon = (props)=>/*#__PURE__*/ $b0928f15364e7bd2$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M3 18a1 1 0 0 0 .99 1H20a.99.99 0 0 0 1-1v-1H3zm0-7h18V9H3zm0-4h18V6c0-.55-.44-1-.99-1H3.99A.99.99 0 0 0 3 6zm0 8h18v-2H3z"/></svg>`
    }, props));
$b0928f15364e7bd2$var$ListIcon.displayName = 'ListIcon';
var $b0928f15364e7bd2$var$_default = module.exports.default = $b0928f15364e7bd2$var$ListIcon;

});

parcelRegister("bMQf5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $894cb3a16ab5591b$var$_react = $894cb3a16ab5591b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $894cb3a16ab5591b$var$_grid = $894cb3a16ab5591b$var$_interopRequireDefault((parcelRequire("jBP3E")));
function $894cb3a16ab5591b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $894cb3a16ab5591b$var$MediaServicesGridIcon = (props)=>/*#__PURE__*/ $894cb3a16ab5591b$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="8" x="3" y="3" rx="1"/><rect width="8" height="8" x="3" y="13" rx="1"/><rect width="8" height="8" x="13" y="3" rx="1"/><rect width="8" height="8" x="13" y="13" rx="1"/></g></svg>`
    }, props, {
        newIcon: $894cb3a16ab5591b$var$_grid.default
    }));
$894cb3a16ab5591b$var$MediaServicesGridIcon.displayName = 'MediaServicesGridIcon';
var $894cb3a16ab5591b$var$_default = module.exports.default = $894cb3a16ab5591b$var$MediaServicesGridIcon;

});
parcelRegister("jBP3E", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4362663ac35e79a0a9cff3b383986020>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e469140f88ae2f4d$var$_react = $e469140f88ae2f4d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e469140f88ae2f4d$var$_UNSAFE_baseNew = $e469140f88ae2f4d$var$_interopRequireDefault((parcelRequire("huIZN")));
function $e469140f88ae2f4d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Grid".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: spaces in Confluence, and grid view, all content in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e469140f88ae2f4d$var$GridIcon = (props)=>/*#__PURE__*/ $e469140f88ae2f4d$var$_react.default.createElement($e469140f88ae2f4d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 1.75H3c-.69 0-1.25.56-1.25 1.25v5M8 1.75h5c.69 0 1.25.56 1.25 1.25v5M8 1.75v12.5m0 0h5c.69 0 1.25-.56 1.25-1.25V8M8 14.25H3c-.69 0-1.25-.56-1.25-1.25V8m0 0h12.5"/>`
    }, props));
$e469140f88ae2f4d$var$GridIcon.displayName = 'GridIcon';
var $e469140f88ae2f4d$var$_default = module.exports.default = $e469140f88ae2f4d$var$GridIcon;

});


parcelRegister("2hGgM", function(module, exports) {
module.exports = new URL("search-empty-state.bd1585ad.svg", import.meta.url).toString();

});

const $ff7f6bf1045148f7$export$c5ccaba974d9b5b6 = 'THUMBNAIL';
const $ff7f6bf1045148f7$export$9586318477fbfa73 = 'LIST';

parcelRegister("41QKo", function(module, exports) {

$parcel$export(module.exports, "ListView", () => $7105da54e4aad1e7$export$84d0dd190d551cd1);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dIdda = parcelRequire("dIdda");

var $45O0y = parcelRequire("45O0y");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $7H02e = parcelRequire("7H02e");

var $6Bqar = parcelRequire("6Bqar");
const $7105da54e4aad1e7$export$84d0dd190d551cd1 = ({ reportsConfig: reportsConfig })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { push: push }] = (0, $dIdda.useRouter)();
    const [rows, setRows] = (0, $5uXOq.useState)([]);
    const head = {
        cells: [
            {
                key: 'report',
                content: formatMessage((0, $6Bqar.default).reportTableHeading)
            },
            reportsConfig.length > 0 && reportsConfig.every((config)=>config.id === 'assets-reports-home-page') ? {
                key: 'actions',
                content: formatMessage((0, $6Bqar.default).actionsTableHeading)
            } : {
                key: 'category',
                content: formatMessage((0, $6Bqar.default).categoruTableHeading)
            }
        ]
    };
    (0, $5uXOq.useEffect)(()=>{
        const tableRow = [];
        reportsConfig.forEach((config)=>{
            config.reports.forEach((report, i)=>{
                tableRow.push({
                    key: `${config.id}-${i}`,
                    cells: [
                        {
                            key: `report-${config.id}-${i}`,
                            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
                                xcss: $7105da54e4aad1e7$var$cell
                            }, report.title)
                        },
                        config.sectionName === '' ? {
                            key: `actions-${config.id}-${i}`,
                            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
                                xcss: $7105da54e4aad1e7$var$cell
                            }, report.actions && report.actions?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H02e.ActionsDropdownComponent), {
                                actions: report?.actions
                            }))
                        } : {
                            key: `category-${config.id}-${i}`,
                            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
                                xcss: $7105da54e4aad1e7$var$cell
                            }, config.sectionName)
                        }
                    ],
                    onClick: ()=>{
                        push(report.link);
                    }
                });
            });
        });
        setRows(tableRow);
    }, [
        push,
        reportsConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $7105da54e4aad1e7$var$tableContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $45O0y.default), {
        head: head,
        rows: rows,
        isFixedSize: true
    }));
};
const $7105da54e4aad1e7$var$tableContainer = (0, $jJ1Sb.xcss)({
    marginTop: 'space.200'
});
const $7105da54e4aad1e7$var$cell = (0, $jJ1Sb.xcss)({
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    cursor: 'pointer'
});

});
parcelRegister("45O0y", function(module, exports) {

$parcel$export(module.exports, "default", () => $5917fcb39f65d1f3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ePBXU = parcelRequire("ePBXU");

var $fJ8fu = parcelRequire("fJ8fu");

var $4HnMH = parcelRequire("4HnMH");
class $5917fcb39f65d1f3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            defaultPage: 1,
            isLoading: false,
            isFixedSize: false,
            isRankable: false,
            onSetPage: (0, $ePBXU.default),
            onSort: (0, $ePBXU.default),
            rowsPerPage: Infinity
        };
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4HnMH.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        };
        this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        };
        this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        };
        this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        };
        this.onRankEndHandler = (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $fJ8fu.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}

});
parcelRegister("fJ8fu", function(module, exports) {

$parcel$export(module.exports, "getPageRows", () => $0b4e248d23054ea5$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $0b4e248d23054ea5$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $0b4e248d23054ea5$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $0b4e248d23054ea5$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $0b4e248d23054ea5$export$c476bbe5da59992d);
const $0b4e248d23054ea5$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $0b4e248d23054ea5$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $0b4e248d23054ea5$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $0b4e248d23054ea5$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $0b4e248d23054ea5$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $0b4e248d23054ea5$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $0b4e248d23054ea5$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $0b4e248d23054ea5$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("4HnMH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1662e3bd77a31953$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3tZix = parcelRequire("3tZix");

var $ePBXU = parcelRequire("ePBXU");


var $fJ8fu = parcelRequire("fJ8fu");

var $jzf8j = parcelRequire("jzf8j");

var $jLR0u = parcelRequire("jLR0u");

var $6sIax = parcelRequire("6sIax");

var $jADNY = parcelRequire("jADNY");

var $9U8do = parcelRequire("9U8do");

var $6RegO = parcelRequire("6RegO");

var $6HZYK = parcelRequire("6HZYK");

var $kIKJh = parcelRequire("kIKJh");
function $1662e3bd77a31953$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $84ed9e4a9d8bc04e$export$b6abcf7fa1d94f65:
            return 0, $84ed9e4a9d8bc04e$export$1dee026a19752d6b;
        case 0, $84ed9e4a9d8bc04e$export$1dee026a19752d6b:
            return 0, $84ed9e4a9d8bc04e$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $1662e3bd77a31953$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $ePBXU.default), onSort: providedOnSort = (0, $ePBXU.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $ePBXU.default), onRankEnd: providedOnRankEnd = (0, $ePBXU.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous',
    next: 'Next',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $5uXOq.useState)(false);
    const tableBodyRef = (0, $5uXOq.useRef)(null);
    const onSort = (0, $3tZix.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $3tZix.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $5uXOq.useEffect)(()=>{
        (0, $fJ8fu.validateSortKey)(sortKey, head);
        (0, $fJ8fu.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $84ed9e4a9d8bc04e$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $84ed9e4a9d8bc04e$export$1dee026a19752d6b) : $1662e3bd77a31953$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $fJ8fu.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $84ed9e4a9d8bc04e$export$7b93a10c0fefe3e3) : (0, $84ed9e4a9d8bc04e$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jLR0u.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jLR0u.EmptyViewContainer), {
            testId: testId
        }, emptyView);
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6RegO.default), {
        isLoading: isLoading && rowsExist,
        spinnerSize: spinnerSize,
        targetRef: ()=>tableBodyRef.current,
        testId: testId,
        loadingLabel: loadingLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jzf8j.Table), {
        isFixedSize: isFixedSize,
        "aria-label": label,
        hasDataRow: rowsExist,
        testId: testId,
        isLoading: isLoading
    }, !!caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jzf8j.Caption), null, caption), head && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kIKJh.default), {
        head: head,
        onSort: onSortHandler,
        sortKey: sortKey,
        sortOrder: sortOrder,
        isRanking: isRanking,
        isRankable: isRankable,
        testId: testId
    }), rowsExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1662e3bd77a31953$var$TableBody, {
        ref: tableBodyRef,
        highlightedRowIndex: highlightedRowIndex,
        rows: rows,
        head: head,
        sortKey: sortKey,
        sortOrder: sortOrder,
        rowsPerPage: rowsPerPage,
        page: getPageNumber,
        isFixedSize: isFixedSize || false,
        onPageRowsUpdate: onPageRowsUpdate,
        isTotalPagesControlledExternally: isTotalPagesControlledExternally,
        testId: testId,
        isRankable: isRankable,
        isRanking: isRanking,
        onRankStart: onRankStartHandler,
        onRankEnd: onRankEndHandler,
        isRankingDisabled: isRankingDisabled || isLoading || false
    }))), totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jzf8j.PaginationWrapper), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6HZYK.default), {
        value: getPageNumber,
        onChange: onSetPageHandler,
        total: totalPages,
        i18n: paginationi18n,
        isDisabled: isLoading,
        testId: testId
    })), !rowsExist && emptyBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9U8do.default), {
        isLoading: isLoading,
        spinnerSize: (0, $84ed9e4a9d8bc04e$export$7b93a10c0fefe3e3),
        testId: testId,
        loadingLabel: loadingLabel
    }, emptyBody));
};

const $1662e3bd77a31953$var$RankableTableBody = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("pP0mX")));
const $1662e3bd77a31953$var$TableBody = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6sIax.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jADNY.ErrorBoundary), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1662e3bd77a31953$var$RankableTableBody, {
        ref: ref,
        ...bodyProps,
        isRanking: isRanking,
        onRankStart: onRankStart,
        onRankEnd: onRankEnd,
        isRankingDisabled: isRankingDisabled
    }))) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1662e3bd77a31953$export$2e2bcd8739ae039 = $1662e3bd77a31953$var$DynamicTable;

});
const $84ed9e4a9d8bc04e$export$1dee026a19752d6b = 'ASC';
const $84ed9e4a9d8bc04e$export$b6abcf7fa1d94f65 = 'DESC';
const $84ed9e4a9d8bc04e$export$71dd4c8ecd45e95f = 'small';
const $84ed9e4a9d8bc04e$export$7b93a10c0fefe3e3 = 'large';
const $84ed9e4a9d8bc04e$export$3843c586a90b9cbf = 0.22;

parcelRegister("jzf8j", function(module, exports) {

$parcel$export(module.exports, "tableRowCSSVars", () => $6268977714d3a60f$export$3b9ea2c10c245fdb);
$parcel$export(module.exports, "Table", () => $6268977714d3a60f$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $6268977714d3a60f$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $6268977714d3a60f$export$3e5e12dc01f20a43);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $kI0wk = parcelRequire("kI0wk");
function $6268977714d3a60f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6268977714d3a60f$export$3b9ea2c10c245fdb = {
    CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
    CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
    CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
    CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
};
const $6268977714d3a60f$var$fixedSizeTableStyles = {
    name: "wgb42e",
    styles: "table-layout:fixed"
};
const $6268977714d3a60f$var$tableStyles = {
    name: "mul4pg",
    styles: "width:100%;border-collapse:separate;border-spacing:0px"
};
const $6268977714d3a60f$var$bodyBorder = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $kI0wk.tableBorder).borderColor}`
});
const $6268977714d3a60f$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("table", {
        inert: isLoading ? '' : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$6268977714d3a60f$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND]: (0, $kI0wk.row).hoverBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$6268977714d3a60f$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND]: (0, $kI0wk.row).highlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$6268977714d3a60f$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND]: (0, $kI0wk.row).hoverHighlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$6268977714d3a60f$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE]: (0, $kI0wk.row).focusOutline
        },
        css: [
            $6268977714d3a60f$var$tableStyles,
            isFixedSize && $6268977714d3a60f$var$fixedSizeTableStyles,
            hasDataRow && $6268977714d3a60f$var$bodyBorder
        ],
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`
    }, children);
});
const $6268977714d3a60f$var$captionStyles = {
    name: "h9a27i",
    styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-100, 8px);margin-block-start:var(--ds-space-300, 24px);will-change:transform"
};
const $6268977714d3a60f$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("caption", {
        css: $6268977714d3a60f$var$captionStyles
    }, children);
const $6268977714d3a60f$var$paginationWrapperStyles = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $6268977714d3a60f$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6268977714d3a60f$var$paginationWrapperStyles,
        "data-testid": testId && `${testId}--pagination--container`
    }, children);

});
parcelRegister("kI0wk", function(module, exports) {

$parcel$export(module.exports, "MSThemeColors", () => $9974f44b1695e005$export$34af08ce45c78352);
$parcel$export(module.exports, "arrow", () => $9974f44b1695e005$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "row", () => $9974f44b1695e005$export$120ff0929b202a6d);
$parcel$export(module.exports, "head", () => $9974f44b1695e005$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tableBorder", () => $9974f44b1695e005$export$38d703b73e2cf64d);

const $9974f44b1695e005$export$34af08ce45c78352 = {
    Background: 'Canvas',
    Text: 'CanvasText',
    SelectedBackground: 'Highlight',
    SelectedText: 'HighlightText'
};
const $9974f44b1695e005$export$f2120bbfa5450bd2 = {
    defaultColor: `var(--ds-icon-disabled, ${$5e0c0d4e15efb4a6$export$1ce2d1575d444ceb})`,
    selectedColor: `var(--ds-icon-subtle, ${$5e0c0d4e15efb4a6$export$e2ef2124cf4024b1})`
};
const $9974f44b1695e005$export$120ff0929b202a6d = {
    focusOutline: `var(--ds-border-focused, ${$5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a})`,
    highlightedBackground: `var(--ds-background-selected, ${$5e0c0d4e15efb4a6$export$226de0355ed012f8})`,
    hoverBackground: `var(--ds-background-neutral-subtle-hovered, ${$5e0c0d4e15efb4a6$export$e655ef011c4aa1a2})`,
    hoverHighlightedBackground: `var(--ds-background-selected-hovered, ${$5e0c0d4e15efb4a6$export$8c13c2ee36917869})`
};
const $9974f44b1695e005$export$5fd5031fecdacec3 = {
    textColor: `var(--ds-text-subtlest, ${$5e0c0d4e15efb4a6$export$e2ef2124cf4024b1})`
};
const $9974f44b1695e005$export$38d703b73e2cf64d = {
    borderColor: `var(--ds-border, ${$5e0c0d4e15efb4a6$export$1ce2d1575d444ceb})`
};

});
var $5e0c0d4e15efb4a6$exports = {};

$parcel$export($5e0c0d4e15efb4a6$exports, "R50", () => $5e0c0d4e15efb4a6$export$4b84fd0e2c617bd);
$parcel$export($5e0c0d4e15efb4a6$exports, "R75", () => $5e0c0d4e15efb4a6$export$b34b069eff244586);
$parcel$export($5e0c0d4e15efb4a6$exports, "R100", () => $5e0c0d4e15efb4a6$export$be802dd0d8b57f35);
$parcel$export($5e0c0d4e15efb4a6$exports, "R200", () => $5e0c0d4e15efb4a6$export$60847d42f9da92a6);
$parcel$export($5e0c0d4e15efb4a6$exports, "R300", () => $5e0c0d4e15efb4a6$export$4a7404f376229999);
$parcel$export($5e0c0d4e15efb4a6$exports, "R400", () => $5e0c0d4e15efb4a6$export$2010d0fb4295b346);
$parcel$export($5e0c0d4e15efb4a6$exports, "R500", () => $5e0c0d4e15efb4a6$export$2837b5a1a71d5c02);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y50", () => $5e0c0d4e15efb4a6$export$8d9596b529bbb9cf);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y75", () => $5e0c0d4e15efb4a6$export$41060a744ab0b7ae);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y100", () => $5e0c0d4e15efb4a6$export$1cc05bbbf340e559);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y200", () => $5e0c0d4e15efb4a6$export$5aae31392d72caaa);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y300", () => $5e0c0d4e15efb4a6$export$c6930421db9fa514);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y400", () => $5e0c0d4e15efb4a6$export$59619663aa6500fb);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y500", () => $5e0c0d4e15efb4a6$export$874739ea9e379ab6);
$parcel$export($5e0c0d4e15efb4a6$exports, "G50", () => $5e0c0d4e15efb4a6$export$8a6341c32b6a3ee6);
$parcel$export($5e0c0d4e15efb4a6$exports, "G75", () => $5e0c0d4e15efb4a6$export$69a3bf21b9686c2b);
$parcel$export($5e0c0d4e15efb4a6$exports, "G100", () => $5e0c0d4e15efb4a6$export$afbce1382ec95f73);
$parcel$export($5e0c0d4e15efb4a6$exports, "G200", () => $5e0c0d4e15efb4a6$export$747d86715d4175de);
$parcel$export($5e0c0d4e15efb4a6$exports, "G300", () => $5e0c0d4e15efb4a6$export$940e1f69e873f202);
$parcel$export($5e0c0d4e15efb4a6$exports, "G400", () => $5e0c0d4e15efb4a6$export$a49394138f7b8e85);
$parcel$export($5e0c0d4e15efb4a6$exports, "G500", () => $5e0c0d4e15efb4a6$export$6fa04827ac68a4fb);
$parcel$export($5e0c0d4e15efb4a6$exports, "B50", () => $5e0c0d4e15efb4a6$export$226de0355ed012f8);
$parcel$export($5e0c0d4e15efb4a6$exports, "B75", () => $5e0c0d4e15efb4a6$export$8c13c2ee36917869);
$parcel$export($5e0c0d4e15efb4a6$exports, "B100", () => $5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a);
$parcel$export($5e0c0d4e15efb4a6$exports, "B200", () => $5e0c0d4e15efb4a6$export$215b7063051591f1);
$parcel$export($5e0c0d4e15efb4a6$exports, "B300", () => $5e0c0d4e15efb4a6$export$e62e8919cca44969);
$parcel$export($5e0c0d4e15efb4a6$exports, "B400", () => $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64);
$parcel$export($5e0c0d4e15efb4a6$exports, "B500", () => $5e0c0d4e15efb4a6$export$a6ee3d71bc067634);
$parcel$export($5e0c0d4e15efb4a6$exports, "B600", () => $5e0c0d4e15efb4a6$export$67f15409e87642a1);
$parcel$export($5e0c0d4e15efb4a6$exports, "B700", () => $5e0c0d4e15efb4a6$export$f0539dbc42dbb067);
$parcel$export($5e0c0d4e15efb4a6$exports, "P50", () => $5e0c0d4e15efb4a6$export$363e4475840015bb);
$parcel$export($5e0c0d4e15efb4a6$exports, "P75", () => $5e0c0d4e15efb4a6$export$4b0a4417ed59760f);
$parcel$export($5e0c0d4e15efb4a6$exports, "P100", () => $5e0c0d4e15efb4a6$export$6011520a64d9a187);
$parcel$export($5e0c0d4e15efb4a6$exports, "P200", () => $5e0c0d4e15efb4a6$export$a7175d4e9206bc80);
$parcel$export($5e0c0d4e15efb4a6$exports, "P300", () => $5e0c0d4e15efb4a6$export$b48405b95304b5a1);
$parcel$export($5e0c0d4e15efb4a6$exports, "P400", () => $5e0c0d4e15efb4a6$export$c71e4279dd54a18d);
$parcel$export($5e0c0d4e15efb4a6$exports, "P500", () => $5e0c0d4e15efb4a6$export$147899de772240ec);
$parcel$export($5e0c0d4e15efb4a6$exports, "T50", () => $5e0c0d4e15efb4a6$export$2cf711fe14c66f06);
$parcel$export($5e0c0d4e15efb4a6$exports, "T75", () => $5e0c0d4e15efb4a6$export$7a8f4d33f6f9772c);
$parcel$export($5e0c0d4e15efb4a6$exports, "T100", () => $5e0c0d4e15efb4a6$export$776c9c497ef08533);
$parcel$export($5e0c0d4e15efb4a6$exports, "T200", () => $5e0c0d4e15efb4a6$export$69cb3ca10c1e330e);
$parcel$export($5e0c0d4e15efb4a6$exports, "T300", () => $5e0c0d4e15efb4a6$export$9dc1ef0f3f48059b);
$parcel$export($5e0c0d4e15efb4a6$exports, "T400", () => $5e0c0d4e15efb4a6$export$7c835c78b6fcdef8);
$parcel$export($5e0c0d4e15efb4a6$exports, "T500", () => $5e0c0d4e15efb4a6$export$6036577f95c3877e);
$parcel$export($5e0c0d4e15efb4a6$exports, "N0", () => $5e0c0d4e15efb4a6$export$29a4f05edc054374);
$parcel$export($5e0c0d4e15efb4a6$exports, "N10", () => $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2);
$parcel$export($5e0c0d4e15efb4a6$exports, "N20", () => $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97);
$parcel$export($5e0c0d4e15efb4a6$exports, "N30", () => $5e0c0d4e15efb4a6$export$3e51e8f1440314ba);
$parcel$export($5e0c0d4e15efb4a6$exports, "N40", () => $5e0c0d4e15efb4a6$export$1ce2d1575d444ceb);
$parcel$export($5e0c0d4e15efb4a6$exports, "N50", () => $5e0c0d4e15efb4a6$export$8754fc7e6d8b3000);
$parcel$export($5e0c0d4e15efb4a6$exports, "N60", () => $5e0c0d4e15efb4a6$export$c2e91cbeada39b8b);
$parcel$export($5e0c0d4e15efb4a6$exports, "N70", () => $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de);
$parcel$export($5e0c0d4e15efb4a6$exports, "N80", () => $5e0c0d4e15efb4a6$export$eaa8c8a70ac22806);
$parcel$export($5e0c0d4e15efb4a6$exports, "N90", () => $5e0c0d4e15efb4a6$export$7c87d337fb91a97d);
$parcel$export($5e0c0d4e15efb4a6$exports, "N100", () => $5e0c0d4e15efb4a6$export$d6447c357493214f);
$parcel$export($5e0c0d4e15efb4a6$exports, "N200", () => $5e0c0d4e15efb4a6$export$f563ee71e9ee74cd);
$parcel$export($5e0c0d4e15efb4a6$exports, "N300", () => $5e0c0d4e15efb4a6$export$e2ef2124cf4024b1);
$parcel$export($5e0c0d4e15efb4a6$exports, "N400", () => $5e0c0d4e15efb4a6$export$eece5f492e429f08);
$parcel$export($5e0c0d4e15efb4a6$exports, "N500", () => $5e0c0d4e15efb4a6$export$c39c0fe0f26207ae);
$parcel$export($5e0c0d4e15efb4a6$exports, "N600", () => $5e0c0d4e15efb4a6$export$7090862dc3038a9f);
$parcel$export($5e0c0d4e15efb4a6$exports, "N700", () => $5e0c0d4e15efb4a6$export$ad0bacf983b7ddaa);
$parcel$export($5e0c0d4e15efb4a6$exports, "N800", () => $5e0c0d4e15efb4a6$export$7d61b15e0da132af);
$parcel$export($5e0c0d4e15efb4a6$exports, "N900", () => $5e0c0d4e15efb4a6$export$fbda843f0a27fe96);
$parcel$export($5e0c0d4e15efb4a6$exports, "N10A", () => $5e0c0d4e15efb4a6$export$791e57b27ca738ef);
$parcel$export($5e0c0d4e15efb4a6$exports, "N20A", () => $5e0c0d4e15efb4a6$export$8d43898f60b96a82);
$parcel$export($5e0c0d4e15efb4a6$exports, "N30A", () => $5e0c0d4e15efb4a6$export$920c0d5c49070351);
$parcel$export($5e0c0d4e15efb4a6$exports, "N40A", () => $5e0c0d4e15efb4a6$export$46987b49aab6d1a8);
$parcel$export($5e0c0d4e15efb4a6$exports, "N50A", () => $5e0c0d4e15efb4a6$export$7d3359664e8bb0e5);
$parcel$export($5e0c0d4e15efb4a6$exports, "N60A", () => $5e0c0d4e15efb4a6$export$d2d3bedfb276cac0);
$parcel$export($5e0c0d4e15efb4a6$exports, "N70A", () => $5e0c0d4e15efb4a6$export$6e5e7499ff054f6d);
$parcel$export($5e0c0d4e15efb4a6$exports, "N80A", () => $5e0c0d4e15efb4a6$export$59264b346c877fa7);
$parcel$export($5e0c0d4e15efb4a6$exports, "N90A", () => $5e0c0d4e15efb4a6$export$d092757d7c64925c);
$parcel$export($5e0c0d4e15efb4a6$exports, "N100A", () => $5e0c0d4e15efb4a6$export$486ab785e4bac3c6);
$parcel$export($5e0c0d4e15efb4a6$exports, "N200A", () => $5e0c0d4e15efb4a6$export$fba592bbc6419fea);
$parcel$export($5e0c0d4e15efb4a6$exports, "N300A", () => $5e0c0d4e15efb4a6$export$13609db0e6812ab8);
$parcel$export($5e0c0d4e15efb4a6$exports, "N400A", () => $5e0c0d4e15efb4a6$export$fbae4efaa892d883);
$parcel$export($5e0c0d4e15efb4a6$exports, "N500A", () => $5e0c0d4e15efb4a6$export$f13946d26f440ce6);
$parcel$export($5e0c0d4e15efb4a6$exports, "N600A", () => $5e0c0d4e15efb4a6$export$19f58225ac52a306);
$parcel$export($5e0c0d4e15efb4a6$exports, "N700A", () => $5e0c0d4e15efb4a6$export$6384f09da70e7b62);
$parcel$export($5e0c0d4e15efb4a6$exports, "N800A", () => $5e0c0d4e15efb4a6$export$d0dccc730683edc2);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN900", () => $5e0c0d4e15efb4a6$export$2f6319cf7d736c2a);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN800", () => $5e0c0d4e15efb4a6$export$95126bc8884d6634);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN700", () => $5e0c0d4e15efb4a6$export$8338d8c35d44ff1);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN600", () => $5e0c0d4e15efb4a6$export$5368d76ae4fbbda7);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN500", () => $5e0c0d4e15efb4a6$export$9f0a771d16ec8d36);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN400", () => $5e0c0d4e15efb4a6$export$abcf8c38338b4aa5);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN300", () => $5e0c0d4e15efb4a6$export$97e81faa16a182c7);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN200", () => $5e0c0d4e15efb4a6$export$bfe21c59123ecf33);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN100", () => $5e0c0d4e15efb4a6$export$ee82aa2ea6a1558);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN90", () => $5e0c0d4e15efb4a6$export$682927c6ed76be02);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN80", () => $5e0c0d4e15efb4a6$export$91fd9994c5be9757);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN70", () => $5e0c0d4e15efb4a6$export$d281fbfe3cff2df6);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN60", () => $5e0c0d4e15efb4a6$export$3902c91d8b98a753);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN50", () => $5e0c0d4e15efb4a6$export$8e8133c1ba5845b5);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN40", () => $5e0c0d4e15efb4a6$export$33ff357f6620b39);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN30", () => $5e0c0d4e15efb4a6$export$633847cf062b69e0);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN20", () => $5e0c0d4e15efb4a6$export$9776a6e503bdbf76);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN10", () => $5e0c0d4e15efb4a6$export$6c813d5160dff5db);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN0", () => $5e0c0d4e15efb4a6$export$3d4f271a500072a);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN800A", () => $5e0c0d4e15efb4a6$export$fe151285c22759ec);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN700A", () => $5e0c0d4e15efb4a6$export$a101c6190d0da34);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN600A", () => $5e0c0d4e15efb4a6$export$4b16f52932fda51);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN500A", () => $5e0c0d4e15efb4a6$export$a74bcd7b9845b0d8);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN400A", () => $5e0c0d4e15efb4a6$export$9209c179316d1751);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN300A", () => $5e0c0d4e15efb4a6$export$88f55133f636c8dd);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN200A", () => $5e0c0d4e15efb4a6$export$51126f85d1009512);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN100A", () => $5e0c0d4e15efb4a6$export$a069b547bd23af78);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN90A", () => $5e0c0d4e15efb4a6$export$40cce05af3b2600a);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN80A", () => $5e0c0d4e15efb4a6$export$b78942185925a0d);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN70A", () => $5e0c0d4e15efb4a6$export$e058fb44b8eaafca);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN60A", () => $5e0c0d4e15efb4a6$export$92b0b8de26920c18);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN50A", () => $5e0c0d4e15efb4a6$export$67564f7459d3fc9e);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN40A", () => $5e0c0d4e15efb4a6$export$77868e1ca884ffa3);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN30A", () => $5e0c0d4e15efb4a6$export$2afd71d7d3ea2cd5);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN20A", () => $5e0c0d4e15efb4a6$export$f2a0acaab9972c70);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN10A", () => $5e0c0d4e15efb4a6$export$9ab70e67d6475361);
$parcel$export($5e0c0d4e15efb4a6$exports, "T30", () => $5e0c0d4e15efb4a6$export$d2adc5dedf09fced);
$parcel$export($5e0c0d4e15efb4a6$exports, "L50", () => $5e0c0d4e15efb4a6$export$f51762073d2bb381);
$parcel$export($5e0c0d4e15efb4a6$exports, "L75", () => $5e0c0d4e15efb4a6$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $5e0c0d4e15efb4a6$export$4b84fd0e2c617bd = '#FFEBE6';
const $5e0c0d4e15efb4a6$export$b34b069eff244586 = '#FFBDAD';
const $5e0c0d4e15efb4a6$export$be802dd0d8b57f35 = '#FF8F73';
const $5e0c0d4e15efb4a6$export$60847d42f9da92a6 = '#FF7452';
const $5e0c0d4e15efb4a6$export$4a7404f376229999 = '#FF5630';
const $5e0c0d4e15efb4a6$export$2010d0fb4295b346 = '#DE350B';
const $5e0c0d4e15efb4a6$export$2837b5a1a71d5c02 = '#BF2600';
const $5e0c0d4e15efb4a6$export$8d9596b529bbb9cf = '#FFFAE6';
const $5e0c0d4e15efb4a6$export$41060a744ab0b7ae = '#FFF0B3';
const $5e0c0d4e15efb4a6$export$1cc05bbbf340e559 = '#FFE380';
const $5e0c0d4e15efb4a6$export$5aae31392d72caaa = '#FFC400';
const $5e0c0d4e15efb4a6$export$c6930421db9fa514 = '#FFAB00';
const $5e0c0d4e15efb4a6$export$59619663aa6500fb = '#FF991F';
const $5e0c0d4e15efb4a6$export$874739ea9e379ab6 = '#FF8B00';
const $5e0c0d4e15efb4a6$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $5e0c0d4e15efb4a6$export$69a3bf21b9686c2b = '#ABF5D1';
const $5e0c0d4e15efb4a6$export$afbce1382ec95f73 = '#79F2C0';
const $5e0c0d4e15efb4a6$export$747d86715d4175de = '#57D9A3';
const $5e0c0d4e15efb4a6$export$940e1f69e873f202 = '#36B37E';
const $5e0c0d4e15efb4a6$export$a49394138f7b8e85 = '#00875A';
const $5e0c0d4e15efb4a6$export$6fa04827ac68a4fb = '#006644';
const $5e0c0d4e15efb4a6$export$226de0355ed012f8 = '#DEEBFF';
const $5e0c0d4e15efb4a6$export$8c13c2ee36917869 = '#B3D4FF';
const $5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a = '#4C9AFF';
const $5e0c0d4e15efb4a6$export$215b7063051591f1 = '#2684FF';
const $5e0c0d4e15efb4a6$export$e62e8919cca44969 = '#0065FF';
const $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64 = '#0052CC';
const $5e0c0d4e15efb4a6$export$a6ee3d71bc067634 = '#0747A6';
const $5e0c0d4e15efb4a6$export$67f15409e87642a1 = '#669DF1';
const $5e0c0d4e15efb4a6$export$f0539dbc42dbb067 = '#8FB8F6';
const $5e0c0d4e15efb4a6$export$363e4475840015bb = '#EAE6FF';
const $5e0c0d4e15efb4a6$export$4b0a4417ed59760f = '#C0B6F2';
const $5e0c0d4e15efb4a6$export$6011520a64d9a187 = '#998DD9';
const $5e0c0d4e15efb4a6$export$a7175d4e9206bc80 = '#8777D9';
const $5e0c0d4e15efb4a6$export$b48405b95304b5a1 = '#6554C0';
const $5e0c0d4e15efb4a6$export$c71e4279dd54a18d = '#5243AA';
const $5e0c0d4e15efb4a6$export$147899de772240ec = '#403294';
const $5e0c0d4e15efb4a6$export$2cf711fe14c66f06 = '#E6FCFF';
const $5e0c0d4e15efb4a6$export$7a8f4d33f6f9772c = '#B3F5FF';
const $5e0c0d4e15efb4a6$export$776c9c497ef08533 = '#79E2F2';
const $5e0c0d4e15efb4a6$export$69cb3ca10c1e330e = '#00C7E6';
const $5e0c0d4e15efb4a6$export$9dc1ef0f3f48059b = '#00B8D9';
const $5e0c0d4e15efb4a6$export$7c835c78b6fcdef8 = '#00A3BF';
const $5e0c0d4e15efb4a6$export$6036577f95c3877e = '#008DA6';
const $5e0c0d4e15efb4a6$export$29a4f05edc054374 = '#FFFFFF';
const $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2 = '#FAFBFC';
const $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97 = '#F4F5F7';
const $5e0c0d4e15efb4a6$export$3e51e8f1440314ba = '#EBECF0';
const $5e0c0d4e15efb4a6$export$1ce2d1575d444ceb = '#DFE1E6';
const $5e0c0d4e15efb4a6$export$8754fc7e6d8b3000 = '#C1C7D0';
const $5e0c0d4e15efb4a6$export$c2e91cbeada39b8b = '#B3BAC5';
const $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de = '#A5ADBA';
const $5e0c0d4e15efb4a6$export$eaa8c8a70ac22806 = '#97A0AF';
const $5e0c0d4e15efb4a6$export$7c87d337fb91a97d = '#8993A4';
const $5e0c0d4e15efb4a6$export$d6447c357493214f = '#7A869A';
const $5e0c0d4e15efb4a6$export$f563ee71e9ee74cd = '#6B778C';
const $5e0c0d4e15efb4a6$export$e2ef2124cf4024b1 = '#5E6C84';
const $5e0c0d4e15efb4a6$export$eece5f492e429f08 = '#505F79';
const $5e0c0d4e15efb4a6$export$c39c0fe0f26207ae = '#42526E';
const $5e0c0d4e15efb4a6$export$7090862dc3038a9f = '#344563';
const $5e0c0d4e15efb4a6$export$ad0bacf983b7ddaa = '#253858';
const $5e0c0d4e15efb4a6$export$7d61b15e0da132af = '#172B4D';
const $5e0c0d4e15efb4a6$export$fbda843f0a27fe96 = '#091E42';
const $5e0c0d4e15efb4a6$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $5e0c0d4e15efb4a6$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $5e0c0d4e15efb4a6$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $5e0c0d4e15efb4a6$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $5e0c0d4e15efb4a6$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $5e0c0d4e15efb4a6$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $5e0c0d4e15efb4a6$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $5e0c0d4e15efb4a6$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $5e0c0d4e15efb4a6$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $5e0c0d4e15efb4a6$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $5e0c0d4e15efb4a6$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $5e0c0d4e15efb4a6$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $5e0c0d4e15efb4a6$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $5e0c0d4e15efb4a6$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $5e0c0d4e15efb4a6$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $5e0c0d4e15efb4a6$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $5e0c0d4e15efb4a6$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $5e0c0d4e15efb4a6$export$2f6319cf7d736c2a = '#E6EDFA';
const $5e0c0d4e15efb4a6$export$95126bc8884d6634 = '#DCE5F5';
const $5e0c0d4e15efb4a6$export$8338d8c35d44ff1 = '#CED9EB';
const $5e0c0d4e15efb4a6$export$5368d76ae4fbbda7 = '#B8C7E0';
const $5e0c0d4e15efb4a6$export$9f0a771d16ec8d36 = '#ABBBD6';
const $5e0c0d4e15efb4a6$export$abcf8c38338b4aa5 = '#9FB0CC';
const $5e0c0d4e15efb4a6$export$97e81faa16a182c7 = '#8C9CB8';
const $5e0c0d4e15efb4a6$export$bfe21c59123ecf33 = '#7988A3';
const $5e0c0d4e15efb4a6$export$ee82aa2ea6a1558 = '#67758F';
const $5e0c0d4e15efb4a6$export$682927c6ed76be02 = '#56637A';
const $5e0c0d4e15efb4a6$export$91fd9994c5be9757 = '#455166';
const $5e0c0d4e15efb4a6$export$d281fbfe3cff2df6 = '#3B475C';
const $5e0c0d4e15efb4a6$export$3902c91d8b98a753 = '#313D52';
const $5e0c0d4e15efb4a6$export$8e8133c1ba5845b5 = '#283447';
const $5e0c0d4e15efb4a6$export$33ff357f6620b39 = '#202B3D';
const $5e0c0d4e15efb4a6$export$633847cf062b69e0 = '#1B2638';
const $5e0c0d4e15efb4a6$export$9776a6e503bdbf76 = '#121A29';
const $5e0c0d4e15efb4a6$export$6c813d5160dff5db = '#0E1624';
const $5e0c0d4e15efb4a6$export$3d4f271a500072a = '#0D1424';
const $5e0c0d4e15efb4a6$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $5e0c0d4e15efb4a6$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $5e0c0d4e15efb4a6$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $5e0c0d4e15efb4a6$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $5e0c0d4e15efb4a6$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $5e0c0d4e15efb4a6$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $5e0c0d4e15efb4a6$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $5e0c0d4e15efb4a6$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $5e0c0d4e15efb4a6$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $5e0c0d4e15efb4a6$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $5e0c0d4e15efb4a6$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $5e0c0d4e15efb4a6$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $5e0c0d4e15efb4a6$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $5e0c0d4e15efb4a6$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $5e0c0d4e15efb4a6$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $5e0c0d4e15efb4a6$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $5e0c0d4e15efb4a6$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $5e0c0d4e15efb4a6$export$d2adc5dedf09fced = '#292A2E';
const $5e0c0d4e15efb4a6$export$f51762073d2bb381 = '#94C748';
const $5e0c0d4e15efb4a6$export$95e26d54def96891 = '#B3DF72';



parcelRegister("jLR0u", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $54cdefac0984b4b4$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $54cdefac0984b4b4$export$381ea436de119582);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $f8Sb3 = parcelRequire("f8Sb3");
function $54cdefac0984b4b4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $54cdefac0984b4b4$var$fixedHeightStyles = {
    name: "50gc26",
    styles: "height:9rem"
};
const $54cdefac0984b4b4$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $54cdefac0984b4b4$var$fixedHeightStyles,
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`
    }, children);
const $54cdefac0984b4b4$var$emptyViewContainerStyles = {
    name: "1yld51o",
    styles: "width:50%;margin:auto;padding:10px;text-align:center"
};
const $54cdefac0984b4b4$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $54cdefac0984b4b4$var$emptyViewContainerStyles,
        "data-testid": testId && `${testId}--empty-view-container`
    }, children);
};

});

parcelRegister("6sIax", function(module, exports) {

$parcel$export(module.exports, "default", () => $53da208a879d72db$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $a9OW0 = parcelRequire("a9OW0");

var $1Pqf3 = parcelRequire("1Pqf3");
class $53da208a879d72db$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef
        }, pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Pqf3.default), {
                head: head,
                isFixedSize: isFixedSize,
                key: row.key || rowIndex,
                row: row,
                isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                testId: testId
            })));
    }
}
const $53da208a879d72db$var$Body = (0, $a9OW0.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($53da208a879d72db$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$53da208a879d72db$export$2e2bcd8739ae039 = $53da208a879d72db$var$Body;

});
parcelRegister("a9OW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $edbcee14c230083b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $fJ8fu = parcelRequire("fJ8fu");
const $edbcee14c230083b$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $edbcee14c230083b$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $84ed9e4a9d8bc04e$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $edbcee14c230083b$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $edbcee14c230083b$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $edbcee14c230083b$export$2e2bcd8739ae039(WrappedComponent) {
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $fJ8fu.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $edbcee14c230083b$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $fJ8fu.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("1Pqf3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4779384176b4c279$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iUcq0 = parcelRequire("iUcq0");

var $3XgHO = parcelRequire("3XgHO");
const $4779384176b4c279$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3XgHO.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
    }, cells.map((cell, cellIndex)=>{
        const { content: content, testId: cellTestId, ...restCellProps } = cell;
        const { shouldTruncate: shouldTruncate, width: width } = (head || {
            cells: []
        }).cells[cellIndex] || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iUcq0.TableBodyCell), {
            "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
            ...restCellProps,
            isFixedSize: isFixedSize,
            key: cellIndex,
            shouldTruncate: shouldTruncate,
            width: width
        }, content);
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4779384176b4c279$export$2e2bcd8739ae039 = $4779384176b4c279$var$Row;

});
parcelRegister("iUcq0", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", () => $d30ee5ee0063c639$export$948e91fcef170792);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $1m2mo = parcelRequire("1m2mo");
const $d30ee5ee0063c639$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $1m2mo.getTruncationStyleVars)({
            width: width
        }),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $1m2mo.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $1m2mo.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && (0, $1m2mo.overflowTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $1m2mo.cellStyles)
        ],
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        ...props
    });

});
parcelRegister("1m2mo", function(module, exports) {

$parcel$export(module.exports, "truncationWidthStyles", () => $d8ccab06ac906831$export$708a733455f59a29);
$parcel$export(module.exports, "fixedSizeTruncateStyles", () => $d8ccab06ac906831$export$616c93ee022c8812);
$parcel$export(module.exports, "overflowTruncateStyles", () => $d8ccab06ac906831$export$7f2cd17defa265d8);
$parcel$export(module.exports, "getTruncationStyleVars", () => $d8ccab06ac906831$export$5e6497a652ae30b5);
$parcel$export(module.exports, "cellStyles", () => $d8ccab06ac906831$export$f7913df521f684e2);

var $f8Sb3 = parcelRequire("f8Sb3");
function $d8ccab06ac906831$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d8ccab06ac906831$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $d8ccab06ac906831$export$708a733455f59a29 = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: `var(${$d8ccab06ac906831$var$CSS_VAR_WIDTH})`
});
const $d8ccab06ac906831$export$616c93ee022c8812 = {
    name: "1s7jr4j",
    styles: "text-overflow:ellipsis;white-space:nowrap"
};
const $d8ccab06ac906831$export$7f2cd17defa265d8 = {
    name: "d3v9zr",
    styles: "overflow:hidden"
};
const $d8ccab06ac906831$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$d8ccab06ac906831$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;
const $d8ccab06ac906831$export$f7913df521f684e2 = /*#__PURE__*/ (0, $f8Sb3.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
    border: 'none',
    textAlign: 'left',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        paddingInlineStart: "var(--ds-space-0, 0px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:last-child': {
        paddingInlineEnd: "var(--ds-space-0, 0px)"
    }
});

});


parcelRegister("3XgHO", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", () => $af2d9e5a0754aac8$export$45f39d9c38b886d5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $jzf8j = parcelRequire("jzf8j");
const $af2d9e5a0754aac8$var$rowStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    '&:focus-visible': {
        outline: `2px solid ${`var(--ds-border-focused, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $jzf8j.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`}`,
        outlineOffset: `-2px`
    }
});
const $af2d9e5a0754aac8$var$rowBackgroundStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $jzf8j.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`
    }
});
const $af2d9e5a0754aac8$var$rowHighlightedBackgroundStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    backgroundColor: `var(--ds-background-selected, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    `var(${(0, $jzf8j.tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $jzf8j.tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
    }
});
const $af2d9e5a0754aac8$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        css: [
            $af2d9e5a0754aac8$var$rowStyles,
            isHighlighted ? $af2d9e5a0754aac8$var$rowHighlightedBackgroundStyles : $af2d9e5a0754aac8$var$rowBackgroundStyles
        ],
        ...rest,
        ref: ref,
        "data-testid": testId
    }, children);
});

});



parcelRegister("jADNY", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $7fe634067da084ba$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");
class $7fe634067da084ba$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("9U8do", function(module, exports) {

$parcel$export(module.exports, "default", () => $a976c8ae95331425$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9MjbF = parcelRequire("9MjbF");


var $iCYjE = parcelRequire("iCYjE");
class $a976c8ae95331425$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $84ed9e4a9d8bc04e$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $84ed9e4a9d8bc04e$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iCYjE.Container), {
            testId: testId
        }, !isLoading ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iCYjE.ContentsContainer), {
            contentsOpacity: contentsOpacity,
            testId: testId
        }, children), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iCYjE.SpinnerContainer), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9MjbF.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        })));
    }
}

});
parcelRegister("iCYjE", function(module, exports) {

$parcel$export(module.exports, "Container", () => $8c5b5a3e0d77de99$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $8c5b5a3e0d77de99$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $8c5b5a3e0d77de99$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $f8Sb3 = parcelRequire("f8Sb3");
function $8c5b5a3e0d77de99$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8c5b5a3e0d77de99$export$c335a80381ec61f5 = '--contents-opacity';
const $8c5b5a3e0d77de99$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $8c5b5a3e0d77de99$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $8c5b5a3e0d77de99$var$containerStyles,
        "data-testid": testId && `${testId}--container`
    }, children);
const $8c5b5a3e0d77de99$var$contentsContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    opacity: `var(${$8c5b5a3e0d77de99$export$c335a80381ec61f5})`,
    pointerEvents: 'none'
});
const $8c5b5a3e0d77de99$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$8c5b5a3e0d77de99$export$c335a80381ec61f5]: contentsOpacity
        },
        css: [
            $8c5b5a3e0d77de99$var$contentsContainerStyles
        ],
        "data-testid": testId && `${testId}--contents--container`
    }, children);
const $8c5b5a3e0d77de99$var$spinnerContainerStyles = {
    name: "su4u96",
    styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center"
};
const $8c5b5a3e0d77de99$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $8c5b5a3e0d77de99$var$spinnerContainerStyles,
        "data-testid": testId && `${testId}--spinner--container`
    }, children);

});


parcelRegister("6RegO", function(module, exports) {

$parcel$export(module.exports, "default", () => $73246af8667d57d9$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $5uXOq = parcelRequire("5uXOq");

var $9MjbF = parcelRequire("9MjbF");


var $57cqj = parcelRequire("57cqj");
class $73246af8667d57d9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $84ed9e4a9d8bc04e$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $84ed9e4a9d8bc04e$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57cqj.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef
        }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57cqj.SpinnerBackdrop), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57cqj.SpinnerContainer), {
            ref: this.spinnerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9MjbF.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        }))));
    }
    constructor(...args){
        super(...args);
        this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef();
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef();
        this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        };
        this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        };
        this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        };
        this.componentWillUnmount = ()=>{
            this.detachListeners();
        };
        this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        };
        this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps);
        this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        };
        this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        };
        this.handleResize = ()=>{
            this.updateSpinnerPosition();
        };
        this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        };
        this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        };
        this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("57cqj", function(module, exports) {

$parcel$export(module.exports, "Container", () => $e96fc2e7276db978$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $e96fc2e7276db978$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $e96fc2e7276db978$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
function $e96fc2e7276db978$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e96fc2e7276db978$var$containerStyles = {
    name: "17fhw1k",
    styles: "position:relative;margin-block-end:var(--ds-space-300, 24px)"
};
const $e96fc2e7276db978$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $e96fc2e7276db978$var$containerStyles,
        ...rest,
        "data-testid": testId,
        ref: ref
    }, children));
});
const $e96fc2e7276db978$var$spinnerBackdropStyles = {
    name: "1yy6mjk",
    styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center;pointer-events:none"
};
const $e96fc2e7276db978$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $e96fc2e7276db978$var$spinnerBackdropStyles,
        "data-testid": testId && `${testId}--spinner-backdrop`
    }, children);
const $e96fc2e7276db978$var$spinnerContainerStyles = {
    name: "vi3nlf",
    styles: "position:relative;inset-block-start:0"
};
const $e96fc2e7276db978$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $e96fc2e7276db978$var$spinnerContainerStyles,
        ref: ref
    }, children));

});


parcelRegister("6HZYK", function(module, exports) {

$parcel$export(module.exports, "default", () => $37c1df4e208237d5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4qDpj = parcelRequire("4qDpj");
class $37c1df4e208237d5$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4qDpj.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args);
        this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("4qDpj", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc085b9842df5f8f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3tZix = parcelRequire("3tZix");

var $ePBXU = parcelRequire("ePBXU");

var $hpEeR = parcelRequire("hpEeR");

var $g8eK6 = parcelRequire("g8eK6");

var $vdokb = parcelRequire("vdokb");

var $6T4rd = parcelRequire("6T4rd");
var $dsFR3 = parcelRequire("dsFR3");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $ir5yp = parcelRequire("ir5yp");

var $59CZH = parcelRequire("59CZH");

var $2gMRD = parcelRequire("2gMRD");

var $hHMPU = parcelRequire("hHMPU");

var $iEuL0 = parcelRequire("iEuL0");
const $cc085b9842df5f8f$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $cc085b9842df5f8f$var$paginationMenuStyles = (0, $jJ1Sb.xcss)({
    padding: 'space.0',
    margin: 'space.0'
});
const $cc085b9842df5f8f$var$paginationMenuItemStyles = (0, $jJ1Sb.xcss)({
    marginBlockStart: 'space.0'
});
const $cc085b9842df5f8f$var$navigatorIconWrapperStyles = (0, $jJ1Sb.xcss)({
    paddingInline: 'space.075'
});
function $cc085b9842df5f8f$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($g8eK6))) : (0, (/*@__PURE__*/$parcel$interopDefault($vdokb)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        as: "span",
        xcss: $cc085b9842df5f8f$var$navigatorIconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Chevron, {
        label: "",
        LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
        color: "currentColor"
    }));
}
function $cc085b9842df5f8f$var$InnerPagination({ components: components = (0, $hHMPU.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $hHMPU.emptyObject), max: max = 7, onChange: onChange = (0, $ePBXU.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $2gMRD.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $hpEeR.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $3tZix.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$cc085b9842df5f8f$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), {
            as: "li",
            xcss: $cc085b9842df5f8f$var$paginationMenuItemStyles,
            key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $59CZH.default), {
            component: components.Page,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: currPageIndex
                }),
            "aria-current": isCurrentPage ? 'page' : undefined,
            "aria-label": pageIndexLabel,
            isSelected: isCurrentPage,
            isDisabled: isDisabled,
            page: page,
            testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
        }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), {
        space: "space.0",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ir5yp.default), {
        key: "left-navigator",
        component: components.Previous,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue - 1
            }),
        isDisabled: isDisabled || selectedIndexValue === 0,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc085b9842df5f8f$var$NavigatorIcon, {
            chevronDirection: "left"
        }),
        "aria-label": previousLabel,
        testId: testId && `${testId}--left-navigator`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), {
        space: "space.0",
        alignBlock: "baseline",
        as: "ul",
        xcss: $cc085b9842df5f8f$var$paginationMenuStyles
    }, (0, $iEuL0.default)(pages, selectedIndexValue, {
        max: max,
        ellipsis: renderEllipsis,
        transform: transform
    }, testId)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ir5yp.default), {
        key: "right-navigator",
        component: components.Next,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue + 1
            }),
        isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc085b9842df5f8f$var$NavigatorIcon, {
            chevronDirection: "right"
        }),
        "aria-label": nextLabel,
        testId: testId && `${testId}--right-navigator`
    }))));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $cc085b9842df5f8f$var$Pagination = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)($cc085b9842df5f8f$var$InnerPagination));
var $cc085b9842df5f8f$export$2e2bcd8739ae039 = $cc085b9842df5f8f$var$Pagination;

});
parcelRegister("g8eK6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17932ebf54d3f380634494a3a0e710ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bbe8d442bfeee8c1$var$_react = $bbe8d442bfeee8c1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bbe8d442bfeee8c1$var$_chevronLeft = $bbe8d442bfeee8c1$var$_interopRequireDefault((parcelRequire("afR4G")));

var $bbe8d442bfeee8c1$var$_chevronLeftLarge = $bbe8d442bfeee8c1$var$_interopRequireDefault((parcelRequire("8IaEt")));
function $bbe8d442bfeee8c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bbe8d442bfeee8c1$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $bbe8d442bfeee8c1$var$_react.default.createElement($bbe8d442bfeee8c1$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $bbe8d442bfeee8c1$var$_chevronLeftLarge.default
    }, props));
$bbe8d442bfeee8c1$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $bbe8d442bfeee8c1$var$_default = module.exports.default = $bbe8d442bfeee8c1$var$ChevronLeftIcon;

});
parcelRegister("afR4G", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53517bd082840f7b30aeaa6b952f5491>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7774799861463016$var$_react = $7774799861463016$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7774799861463016$var$_UNSAFE_baseNew = $7774799861463016$var$_interopRequireDefault((parcelRequire("huIZN")));
function $7774799861463016$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7774799861463016$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $7774799861463016$var$_react.default.createElement($7774799861463016$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$7774799861463016$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $7774799861463016$var$_default = module.exports.default = $7774799861463016$var$ChevronLeftIcon;

});

parcelRegister("8IaEt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $657ab203f947a458$var$_react = $657ab203f947a458$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $657ab203f947a458$var$_chevronLeft = $657ab203f947a458$var$_interopRequireDefault((parcelRequire("afR4G")));
function $657ab203f947a458$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $657ab203f947a458$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $657ab203f947a458$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $657ab203f947a458$var$_chevronLeft.default,
        iconType: "utility"
    }));
$657ab203f947a458$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $657ab203f947a458$var$_default = module.exports.default = $657ab203f947a458$var$ChevronLeftLargeIcon;

});


parcelRegister("vdokb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ef383524276f158d595d267ad16f45a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05dd489ad229a550$var$_react = $05dd489ad229a550$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $05dd489ad229a550$var$_chevronRight = $05dd489ad229a550$var$_interopRequireDefault((parcelRequire("cSFUi")));

var $05dd489ad229a550$var$_chevronRightLarge = $05dd489ad229a550$var$_interopRequireDefault((parcelRequire("kerag")));
function $05dd489ad229a550$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $05dd489ad229a550$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $05dd489ad229a550$var$_react.default.createElement($05dd489ad229a550$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $05dd489ad229a550$var$_chevronRightLarge.default
    }, props));
$05dd489ad229a550$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $05dd489ad229a550$var$_default = module.exports.default = $05dd489ad229a550$var$ChevronRightIcon;

});
parcelRegister("kerag", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ebaa2fc30df9d900$var$_react = $ebaa2fc30df9d900$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $ebaa2fc30df9d900$var$_chevronRight = $ebaa2fc30df9d900$var$_interopRequireDefault((parcelRequire("cSFUi")));
function $ebaa2fc30df9d900$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ebaa2fc30df9d900$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $ebaa2fc30df9d900$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $ebaa2fc30df9d900$var$_chevronRight.default,
        iconType: "utility"
    }));
$ebaa2fc30df9d900$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $ebaa2fc30df9d900$var$_default = module.exports.default = $ebaa2fc30df9d900$var$ChevronRightLargeIcon;

});


parcelRegister("ir5yp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2ea1965bd5ec3ed$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $89thI = parcelRequire("89thI");
function $c2ea1965bd5ec3ed$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("59CZH", function(module, exports) {

$parcel$export(module.exports, "default", () => $56e3a9a9eebcabfb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $89thI = parcelRequire("89thI");
function $56e3a9a9eebcabfb$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("2gMRD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7a0e0d0a90cae6f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6T4rd = parcelRequire("6T4rd");
var $1m92z = parcelRequire("1m92z");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $8tUJa = parcelRequire("8tUJa");
const $f7a0e0d0a90cae6f$var$containerStyles = (0, $jJ1Sb.xcss)({
    display: 'flex',
    position: 'relative'
});
function $f7a0e0d0a90cae6f$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        as: "li",
        testId: testId,
        key: key,
        xcss: $f7a0e0d0a90cae6f$var$containerStyles,
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1m92z.default), {
        testId: testId && `${testId}-text`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8tUJa.default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
}

});

parcelRegister("hHMPU", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $f762102d0338cc3f$export$3f860eba1218f8d3);
const $f762102d0338cc3f$export$3f860eba1218f8d3 = {};

});

parcelRegister("iEuL0", function(module, exports) {

$parcel$export(module.exports, "default", () => $498d7e9a00b3b2c9$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $498d7e9a00b3b2c9$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $8QpSo.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $498d7e9a00b3b2c9$export$2e2bcd8739ae039 = $498d7e9a00b3b2c9$var$collapseRange;

});



parcelRegister("kIKJh", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ad77d12c9a6c0a5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fJ8fu = parcelRequire("fJ8fu");

var $70ohB = parcelRequire("70ohB");

var $k3WmL = parcelRequire("k3WmL");

var $8W5hl = parcelRequire("8W5hl");
class $1ad77d12c9a6c0a5$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    UNSAFE_componentWillMount() {
        (0, $fJ8fu.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $fJ8fu.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $k3WmL.default) : (0, $8W5hl.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70ohB.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr", null, cells.map((cell, index)=>{
            const { colSpan: colSpan, content: content, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
            // the API.
            ...restCellProps } = cell;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HeadCellComponent, {
                colSpan: colSpan,
                content: content,
                isFixedSize: isFixedSize,
                isSortable: !!isSortable,
                isRanking: isRanking,
                key: key || index,
                onClick: isSortable ? onSort(cell) : undefined,
                testId: cellTestId || testId,
                shouldTruncate: shouldTruncate,
                sortOrder: key === sortKey ? sortOrder : undefined,
                width: width,
                ...restCellProps
            });
        })));
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1ad77d12c9a6c0a5$export$2e2bcd8739ae039 = $1ad77d12c9a6c0a5$var$TableHead;

});
parcelRegister("70ohB", function(module, exports) {

$parcel$export(module.exports, "Head", () => $0db5b585a9120982$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $0db5b585a9120982$export$4e8024263ace498b);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");



var $kI0wk = parcelRequire("kI0wk");

var $1m2mo = parcelRequire("1m2mo");
function $0db5b585a9120982$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0db5b585a9120982$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $0db5b585a9120982$var$rankingStyles = {
    name: "4zleql",
    styles: "display:block"
};
const $0db5b585a9120982$var$headStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    borderBlockEnd: `none`
});
const $0db5b585a9120982$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("thead", {
        css: [
            $0db5b585a9120982$var$headStyles,
            isRanking && $0db5b585a9120982$var$rankingStyles
        ],
        "data-testid": testId,
        ...props
    });
};
const $0db5b585a9120982$var$headCellBaseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    boxSizing: 'border-box',
    position: 'relative',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $kI0wk.tableBorder).borderColor}`,
    color: `var(--ds-text-subtle, ${`var(${$0db5b585a9120982$var$CSS_VAR_TEXT_COLOR})`})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    textAlign: 'left',
    verticalAlign: 'top',
    '&:focus-visible': {
        outline: `solid 2px ${`var(--ds-border-focused, ${(0, $5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a)})`}`
    }
});
const $0db5b585a9120982$var$onClickStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $5e0c0d4e15efb4a6$export$920c0d5c49070351)})`,
        cursor: 'pointer'
    }
});
const $0db5b585a9120982$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        padding: "var(--ds-space-0, 0)",
        position: 'relative',
        appearance: 'none',
        background: 'none',
        border: 'none',
        color: 'inherit',
        cursor: 'inherit',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        '&::before, &::after': {
            display: 'block',
            width: 0,
            height: 0,
            position: 'absolute',
            border: '3px solid transparent',
            content: '""',
            insetInlineEnd: "var(--ds-space-negative-100, -8px)"
        },
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $kI0wk.arrow).defaultColor}`,
            insetBlockEnd: "var(--ds-space-100, 8px)"
        },
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $kI0wk.arrow).defaultColor}`,
            insetBlockEnd: 0
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before, &::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                border: `3px solid ${(0, $kI0wk.MSThemeColors).Background}`
            },
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $kI0wk.MSThemeColors).Text}`
            },
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $kI0wk.MSThemeColors).Text}`
            }
        }
    }
});
const $0db5b585a9120982$var$ascendingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $kI0wk.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $kI0wk.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $0db5b585a9120982$var$descendingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $kI0wk.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $kI0wk.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $0db5b585a9120982$export$4e8024263ace498b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $1m2mo.getTruncationStyleVars)({
            width: width
        }),
        [$0db5b585a9120982$var$CSS_VAR_TEXT_COLOR]: (0, $kI0wk.head).textColor
    };
    const isASC = sortOrder === (0, $84ed9e4a9d8bc04e$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $84ed9e4a9d8bc04e$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $1m2mo.cellStyles),
            $0db5b585a9120982$var$headCellBaseStyles,
            onClick && $0db5b585a9120982$var$onClickStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $1m2mo.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $1m2mo.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && (0, $1m2mo.overflowTruncateStyles),
            isSortable && $0db5b585a9120982$var$baseStyles,
            isASC && $0db5b585a9120982$var$ascendingStyles,
            isDESC && $0db5b585a9120982$var$descendingStyles
        ],
        onClick: onClick,
        ref: ref,
        "data-testid": testId,
        ...rest
    }, children);
});

});

parcelRegister("k3WmL", function(module, exports) {

$parcel$export(module.exports, "default", () => $6486d691c2f08565$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2DzWE = parcelRequire("2DzWE");

var $fJ8fu = parcelRequire("fJ8fu");

var $8W5hl = parcelRequire("8W5hl");
class $6486d691c2f08565$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $fJ8fu.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8W5hl.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $6486d691c2f08565$var$RankableTableHeadCell = (0, $2DzWE.default)($6486d691c2f08565$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6486d691c2f08565$export$2e2bcd8739ae039 = $6486d691c2f08565$var$RankableTableHeadCell;

});
parcelRegister("2DzWE", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf89bc848ceb22a4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $bf89bc848ceb22a4$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                refWidth: 0,
                refHeight: 0
            };
            this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            };
            this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("8W5hl", function(module, exports) {

$parcel$export(module.exports, "default", () => $3231954efe281351$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $70ohB = parcelRequire("70ohB");
const $3231954efe281351$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70ohB.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        onClick: onClick,
        isSortable: isSortable
    }, isSortable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("button", {
        type: "button",
        "aria-roledescription": "Sort button"
    }, content) : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3231954efe281351$export$2e2bcd8739ae039 = $3231954efe281351$var$TableHeadCell;

});



parcelRegister("pP0mX", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("i4UfJ")
]).then(()=>parcelRequire('7mthO'));

});



parcelRegister("7H02e", function(module, exports) {

$parcel$export(module.exports, "ActionsDropdownComponent", () => $f1b14adde6d3a216$export$74d7a11ad6f814bb);

var $5uXOq = parcelRequire("5uXOq");

var $e0OK7 = parcelRequire("e0OK7");

var $8Agsd = parcelRequire("8Agsd");
var $feGGA = parcelRequire("feGGA");
var $iDxSW = parcelRequire("iDxSW");

var $9T1wg = parcelRequire("9T1wg");
const $f1b14adde6d3a216$export$74d7a11ad6f814bb = ({ actions: actions })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Agsd.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0OK7.default), {
                ...props,
                onClick: (event)=>{
                    event.stopPropagation();
                    event.preventDefault();
                    if (props.onClick) props.onClick(event);
                },
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9T1wg))),
                label: "Actions",
                ref: triggerRef,
                spacing: "compact"
            }),
        shouldRenderToParent: true,
        spacing: "compact"
    }, actions && actions.map((actionItem)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDxSW.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $feGGA.default), {
            onClick: (event)=>{
                event.stopPropagation();
                event.preventDefault();
                actionItem.action();
            }
        }, actionItem.name))));
};

});
parcelRegister("feGGA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3706e29c1e2d34bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $oUGyo = parcelRequire("oUGyo");

var $6PItG = parcelRequire("6PItG");

var $eIm7r = parcelRequire("eIm7r");

var $jJ62p = parcelRequire("jJ62p");

var $294ns = parcelRequire("294ns");

var $7jhTK = parcelRequire("7jhTK");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $3706e29c1e2d34bd$var$DropdownMenuItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, ...rest }, ref)=>{
    const itemRef = (0, $7jhTK.default)();
    const handleItemClick = (0, $5uXOq.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eIm7r.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $oUGyo.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...(0, $294ns.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jJ62p.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $oUGyo.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...(0, $294ns.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6PItG.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $oUGyo.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...(0, $294ns.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children);
});
var $3706e29c1e2d34bd$export$2e2bcd8739ae039 = $3706e29c1e2d34bd$var$DropdownMenuItem;

});

parcelRegister("iDxSW", function(module, exports) {

$parcel$export(module.exports, "default", () => $451ae845e5759506$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3QrEQ = parcelRequire("3QrEQ");

var $Hi7fY = parcelRequire("Hi7fY");

var $7SSAv = parcelRequire("7SSAv");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $451ae845e5759506$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $3QrEQ.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Hi7fY.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7SSAv.default), {
        id: titleId,
        title: title
    }), children);
});
var $451ae845e5759506$export$2e2bcd8739ae039 = $451ae845e5759506$var$DropdownMenuItemGroup;

});


parcelRegister("6Bqar", function(module, exports) {

$parcel$export(module.exports, "default", () => $e743cbd2a6aabd0a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e743cbd2a6aabd0a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    reportTableHeading: {
        id: 'spa-apps-servicedesk-reports-home-page.list-view.report-table-heading',
        defaultMessage: 'Title',
        description: 'Table column 1 heading'
    },
    categoruTableHeading: {
        id: 'spa-apps-servicedesk-reports-home-page.list-view.categoru-table-heading',
        defaultMessage: 'Type',
        description: 'Table column 2 heading'
    },
    actionsTableHeading: {
        id: 'spa-apps-servicedesk-reports-home-page.list-view.actions-table-heading',
        defaultMessage: 'Actions',
        description: 'Table column 3 heading'
    }
});

});


parcelRegister("jgvSG", function(module, exports) {

$parcel$export(module.exports, "ThumbnailView", () => $31078355ebc03d7d$export$f06e14e146c0b896);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $4hGw3 = parcelRequire("4hGw3");

var $53KbV = parcelRequire("53KbV");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $fyR67 = parcelRequire("fyR67");

var $gGJGG = parcelRequire("gGJGG");

var $l9HvI = parcelRequire("l9HvI");
const $31078355ebc03d7d$var$RenderSection = ({ sectionName: sectionName, reports: reports, id: id, emptyState: emptyState })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $31078355ebc03d7d$var$sectionContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $53KbV.default), {
        level: "h500"
    }, sectionName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $31078355ebc03d7d$var$cardsContainer
    }, reports.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hGw3.default), {
        header: emptyState?.heading ? emptyState.heading : formatMessage((0, $l9HvI.default).defaultReportsEmptyStateTitle),
        description: emptyState?.description ? emptyState.description : formatMessage((0, $l9HvI.default).defaultReportsEmptyStateDescription),
        headingLevel: 4,
        imageUrl: emptyState?.imageUrl ? emptyState.imageUrl : (0, (/*@__PURE__*/$parcel$interopDefault($fyR67)))
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, reports.map((report, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gGJGG.ThumbnailCard), {
            key: i,
            ...report
        })))));
};
const $31078355ebc03d7d$export$f06e14e146c0b896 = ({ reportsConfig: reportsConfig })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, reportsConfig.map((section)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($31078355ebc03d7d$var$RenderSection, {
            key: section.id,
            ...section
        })));
const $31078355ebc03d7d$var$sectionContainer = (0, $jJ1Sb.xcss)({
    // @ts-expect-error TS2322
    marginTop: "var(--ds-space-300, 24px)",
    display: 'flex',
    flexDirection: 'column',
    // @ts-expect-error TS2322
    gap: "var(--ds-space-200, 16px)"
});
const $31078355ebc03d7d$var$cardsContainer = (0, $jJ1Sb.xcss)({
    display: 'flex',
    flexDirection: 'row',
    // @ts-expect-error TS2322
    gap: "var(--ds-space-200, 16px)",
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});

});
parcelRegister("fyR67", function(module, exports) {
module.exports = new URL("no-reports.a067b4c9.svg", import.meta.url).toString();

});

parcelRegister("gGJGG", function(module, exports) {

$parcel$export(module.exports, "ThumbnailCard", () => $5f8a3499ba353605$export$c48469f77510fecd);

var $5uXOq = parcelRequire("5uXOq");

var $hixTL = parcelRequire("hixTL");

var $29ctK = parcelRequire("29ctK");

var $6T4rd = parcelRequire("6T4rd");
var $dsFR3 = parcelRequire("dsFR3");
var $1m92z = parcelRequire("1m92z");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $MGmIU = parcelRequire("MGmIU");

var $7H02e = parcelRequire("7H02e");
const $5f8a3499ba353605$export$c48469f77510fecd = ({ id: id, thumbnail: thumbnail, title: title, link: link, actions: actions })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $29ctK.default), {
        href: link,
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $5f8a3499ba353605$var$container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $5f8a3499ba353605$var$imageContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hixTL.default), {
        src: thumbnail,
        alt: title
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $5f8a3499ba353605$var$contentContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), {
        grow: "fill",
        xcss: $5f8a3499ba353605$var$thumbnailNameAndActionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), null, title.length > 25 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: title,
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1m92z.default), {
        maxLines: 1,
        size: "medium",
        weight: "bold"
    }, title)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1m92z.default), {
        maxLines: 1,
        size: "medium",
        weight: "bold"
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $5f8a3499ba353605$var$actionsDropdownWrapper
    }, actions && actions?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H02e.ActionsDropdownComponent), {
        actions: actions
    }))))));
};
const $5f8a3499ba353605$var$container = (0, $jJ1Sb.xcss)({
    display: 'flex',
    width: '244px',
    minWidth: '244px',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    borderRadius: "var(--ds-space-050, 4px)",
    cursor: 'pointer',
    outline: `1px solid ${"var(--ds-background-accent-gray-subtler, #DCDFE4)"}`,
    ':hover': {
        outline: `2px solid ${"var(--ds-link, #0C66E4)"}`
    }
});
const $5f8a3499ba353605$var$imageContainer = (0, $jJ1Sb.xcss)({
    width: '100%',
    height: '127px',
    background: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
});
const $5f8a3499ba353605$var$contentContainer = (0, $jJ1Sb.xcss)({
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: 'space.200'
});
const $5f8a3499ba353605$var$thumbnailNameAndActionStyles = (0, $jJ1Sb.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
});
const $5f8a3499ba353605$var$actionsDropdownWrapper = (0, $jJ1Sb.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: '20px',
    maxHeight: '20px'
});

});

parcelRegister("l9HvI", function(module, exports) {

$parcel$export(module.exports, "default", () => $83bfeec39f4e81e2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $83bfeec39f4e81e2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    customReportsEmptyStateDescription: {
        id: 'spa-apps-servicedesk-reports-home-page.thumbnail-view.custom-reports-empty-state-description',
        defaultMessage: "It looks like you\u2019ve not gained permission to custom reports yet. When your account admin adds you, we\u2019ll list them here.",
        description: 'Empty State description'
    },
    defaultReportsEmptyStateDescription: {
        id: 'spa-apps-servicedesk-reports-home-page.thumbnail-view.default-reports-empty-state-description',
        defaultMessage: "It looks like you\u2019ve not gained permission to default reports yet. When your account admin adds you, we\u2019ll list them here.",
        description: 'Empty State description'
    },
    customReportsEmptyStateTitle: {
        id: 'spa-apps-servicedesk-reports-home-page.thumbnail-view.custom-reports-empty-state-title',
        defaultMessage: 'Start creating custom reports',
        description: 'Empty State description'
    },
    defaultReportsEmptyStateTitle: {
        id: 'spa-apps-servicedesk-reports-home-page.thumbnail-view.default-reports-empty-state-title',
        defaultMessage: "Default reports aren\u2019t available",
        description: 'Empty State description'
    }
});

});


parcelRegister("cbRTI", function(module, exports) {

$parcel$export(module.exports, "useReportsHomePageController", () => $89796e558a0bb9c6$export$3e3935874a94a79b);

var $5uXOq = parcelRequire("5uXOq");
const $89796e558a0bb9c6$export$3e3935874a94a79b = (reportsConfig)=>{
    const [searchValue, setSearchValue] = (0, $5uXOq.useState)('');
    const [filteredReportsConfig, setFilteredReportsConfig] = (0, $5uXOq.useState)(reportsConfig);
    (0, $5uXOq.useEffect)(()=>{
        setFilteredReportsConfig(reportsConfig);
    }, [
        reportsConfig,
        setFilteredReportsConfig
    ]);
    const searchForReport = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (event.type !== 'change') return;
        const value = event.target.value;
        setSearchValue(value);
        let filteredResult = reportsConfig.map((config)=>{
            const searchResults = {
                ...config
            };
            searchResults.reports = config.reports.filter((report)=>report.title.toLowerCase().includes(value.toLowerCase()));
            return searchResults;
        });
        filteredResult = filteredResult.filter((config)=>config.reports.length > 0);
        setFilteredReportsConfig(filteredResult);
    }, [
        reportsConfig,
        setSearchValue,
        setFilteredReportsConfig
    ]);
    return {
        searchForReport: searchForReport,
        searchValue: searchValue,
        filteredReportsConfig: filteredReportsConfig
    };
};

});

parcelRegister("Ou5pt", function(module, exports) {

$parcel$export(module.exports, "messages", () => $654cde044dd8ad03$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $654cde044dd8ad03$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    reportsTitle: {
        id: 'jsm.jsm-reports-common.reports-home-page.reports-title',
        defaultMessage: 'Reports',
        description: 'Title for the page'
    },
    searchPlaceholder: {
        id: 'jsm.jsm-reports-common.reports-home-page.search-placeholder',
        defaultMessage: 'Search for reports',
        description: 'Placeholder for searchbox'
    },
    dropdownTrigger: {
        id: 'jsm.jsm-reports-common.reports-home-page.dropdown-trigger',
        defaultMessage: 'Select a team',
        description: 'Dropdown trigger'
    },
    swithcToListViewButton: {
        id: 'jsm.jsm-reports-common.reports-home-page.switch-to-list-view-button',
        defaultMessage: 'Switch to list view',
        description: 'Button to switch to list view'
    },
    swithcToCardViewButton: {
        id: 'jsm.jsm-reports-common.reports-home-page.swithc-to-card-view-button',
        defaultMessage: 'Switch to card view',
        description: 'Button to switch to card view'
    },
    noAccessEmptyStateHeader: {
        id: 'jsm.jsm-reports-common.reports-home-page.no-access-empty-state-header',
        defaultMessage: "Reports aren\u2019t available",
        description: 'Empty State header'
    },
    noAccessEmptyStateDescription: {
        id: 'jsm.jsm-reports-common.reports-home-page.no-access-empty-state-description',
        defaultMessage: "It looks like you\u2019ve not gained permission to reports yet. When your account admin adds you to reports, we\u2019ll list them here.",
        description: 'Empty State description'
    },
    searchEmptyStateTitle: {
        id: 'jsm.jsm-reports-common.reports-home-page.search-empty-state-title',
        defaultMessage: "We couldn\u2019t find anything matching your search",
        description: 'Empty State title'
    },
    searchEmptyStateDescription: {
        id: 'jsm.jsm-reports-common.reports-home-page.search-empty-state-description',
        defaultMessage: 'Try again with a different term',
        description: 'Empty State title'
    }
});

});


parcelRegister("k0laR", function(module, exports) {

$parcel$export(module.exports, "useReportsHomePageController", () => $9c15ba9493e825bd$export$3e3935874a94a79b);

var $5uXOq = parcelRequire("5uXOq");

var $4Pf62 = parcelRequire("4Pf62");

var $koVbs = parcelRequire("koVbs");

var $c2JIK = parcelRequire("c2JIK");

var $eYYbM = parcelRequire("eYYbM");

var $y8WG5 = parcelRequire("y8WG5");

var $jaWUd = parcelRequire("jaWUd");

var $hqBSi = parcelRequire("hqBSi");

var $evdlo = parcelRequire("evdlo");
var $gC6SJ = parcelRequire("gC6SJ");
var $lw9to = parcelRequire("lw9to");
var $j6QL3 = parcelRequire("j6QL3");
var $305uS = parcelRequire("305uS");

var $3dINR = parcelRequire("3dINR");

var $jSYl6 = parcelRequire("jSYl6");
const $9c15ba9493e825bd$export$3e3935874a94a79b = (projectKey)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [reportsConfig, setReportsConfig] = (0, $5uXOq.useState)([]);
    const { data: defaultReports, loading: defaultReportsLoading } = (0, $y8WG5.useReportFeatures)({
        route: (0, $jaWUd.servicedeskReports1Route),
        matchParams: {
            projectKey: projectKey
        }
    });
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const shouldShowAtlassianAnalytics = licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).ATLASSIAN_ANALYTICS];
    const { data: initialCustomReportsFromSidebarConfig, loading: customReportsLoading } = (0, $eYYbM.useCustomReports)();
    const getDefaultReports = (0, $5uXOq.useCallback)((features)=>{
        const reports = [];
        let defaultReportsAccess = false;
        if (features.hasWorkload) {
            defaultReportsAccess = true;
            reports.push({
                link: (0, $c2JIK.createReportUrl)(projectKey, '/workload'),
                thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($305uS))),
                title: formatMessage((0, $jSYl6.default).workload)
            });
        }
        if (features.hasSatisfaction) {
            defaultReportsAccess = true;
            reports.push({
                link: (0, $c2JIK.createReportUrl)(projectKey, '/all-rating'),
                thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($j6QL3))),
                title: formatMessage((0, $jSYl6.default).satisfaction)
            });
        }
        if (features.hasRequestsDeflected) {
            defaultReportsAccess = true;
            reports.push({
                link: (0, $c2JIK.createReportUrl)(projectKey, '/kb-requests-deflected'),
                thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($gC6SJ))),
                title: formatMessage((0, $jSYl6.default).requestsDeflected)
            });
        }
        if (features.hasRequestsDeflected) {
            defaultReportsAccess = true;
            reports.push({
                link: (0, $c2JIK.createReportUrl)(projectKey, '/kb-requests-resolved'),
                thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($lw9to))),
                title: formatMessage((0, $jSYl6.default).requestsResolved)
            });
        }
        if (shouldShowAtlassianAnalytics) {
            defaultReportsAccess = true;
            reports.push({
                link: (0, $c2JIK.createReportUrl)(projectKey, '/atlassian-analytics'),
                thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($evdlo))),
                title: formatMessage((0, $jSYl6.default).analytics)
            });
        }
        return {
            id: (0, $3dINR.REPORT_TYPE).DEFAULT,
            sectionName: formatMessage((0, $jSYl6.default).defaultReportsTitle),
            reports: reports,
            access: defaultReportsAccess
        };
    }, [
        formatMessage,
        projectKey,
        shouldShowAtlassianAnalytics
    ]);
    const getCustomReportsConfig = (0, $5uXOq.useCallback)((config)=>{
        const reports = config.map((report)=>({
                link: __SPA__ ? report.url.replace(/^\/projects/, '/jira/servicedesk/projects') : report.url,
                thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($evdlo))),
                title: report.name
            }));
        return {
            id: (0, $3dINR.REPORT_TYPE).CUSTOM,
            sectionName: formatMessage((0, $jSYl6.default).customReportsTitle),
            reports: reports,
            access: reports.length > 0
        };
    }, [
        formatMessage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (customReportsLoading || defaultReportsLoading) return;
        const config = [];
        if (defaultReports) config.push(getDefaultReports(defaultReports));
        if (initialCustomReportsFromSidebarConfig) config.push(getCustomReportsConfig(initialCustomReportsFromSidebarConfig));
        setReportsConfig(config);
    }, [
        customReportsLoading,
        defaultReportsLoading,
        defaultReports,
        initialCustomReportsFromSidebarConfig,
        getDefaultReports,
        setReportsConfig,
        getCustomReportsConfig
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setLoading(customReportsLoading || defaultReportsLoading);
    }, [
        customReportsLoading,
        defaultReportsLoading,
        setLoading
    ]);
    return {
        reportsConfig: reportsConfig,
        loading: loading
    };
};

});
parcelRegister("eYYbM", function(module, exports) {

$parcel$export(module.exports, "useCustomReports", () => $fe826eecf5ba2b29$export$40ce6c46d343d75f);

var $5uXOq = parcelRequire("5uXOq");

var $aQGK8 = parcelRequire("aQGK8");

var $01b4Y = parcelRequire("01b4Y");
const $fe826eecf5ba2b29$export$40ce6c46d343d75f = ()=>{
    const { data: data, loading: loading } = (0, $aQGK8.useJiraServiceManagementReportsNavigation)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $01b4Y.getCustomReports)(data), [
        data
    ]);
    return {
        data: extractedData,
        loading: loading
    };
};

});
parcelRegister("01b4Y", function(module, exports) {

$parcel$export(module.exports, "getCustomReports", () => $834e3ba61dbfadb5$export$a8c10e0a09026b31);
const $834e3ba61dbfadb5$export$a8c10e0a09026b31 = (data)=>{
    const customReports = data.customReports?.map((report)=>({
            id: `com.atlassian.servicedesk:reports-nav-${report.id}`,
            name: report.name,
            url: report.url
        }));
    return customReports || [];
};

});


parcelRegister("evdlo", function(module, exports) {
module.exports = new URL("custom-reports.800596fa.svg", import.meta.url).toString();

});

parcelRegister("gC6SJ", function(module, exports) {
module.exports = new URL("requests-deflected.5f7b3322.svg", import.meta.url).toString();

});

parcelRegister("lw9to", function(module, exports) {
module.exports = new URL("requests-resolved.11ae9621.svg", import.meta.url).toString();

});

parcelRegister("j6QL3", function(module, exports) {
module.exports = new URL("satisfaction.c6f70195.svg", import.meta.url).toString();

});

parcelRegister("305uS", function(module, exports) {
module.exports = new URL("workload.10f63c26.svg", import.meta.url).toString();

});

parcelRegister("3dINR", function(module, exports) {

$parcel$export(module.exports, "REPORT_TYPE", () => $5400138f83202c8a$export$258957993bf2c8b);
const $5400138f83202c8a$export$c5ccaba974d9b5b6 = 'THUMBNAIL';
const $5400138f83202c8a$export$9586318477fbfa73 = 'LIST';
const $5400138f83202c8a$export$a513ea61a7bee91c = {
    ALL_REPORTS: 'All Reports',
    DEFAULT: 'Default Reports',
    CUSTOM: 'Custom Reports'
};
const $5400138f83202c8a$export$258957993bf2c8b = {
    DEFAULT: 'DEFAULT',
    CUSTOM: 'CUSTOM'
};

});

parcelRegister("jSYl6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf7dda823f3171e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2cf7dda823f3171e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    defaultReportsTitle: {
        "id": "spa-apps-servicedesk-reports-home-page.controllers.home-page-controller.default-reports-title",
        "defaultMessage": "Default"
    },
    customReportsTitle: {
        "id": "spa-apps-servicedesk-reports-home-page.controllers.home-page-controller.custom-reports-title",
        "defaultMessage": "Custom"
    },
    workload: {
        "id": "spa-apps-servicedesk-reports-home-page.controllers.home-page-controller.workload",
        "defaultMessage": "Workload"
    },
    satisfaction: {
        "id": "spa-apps-servicedesk-reports-home-page.controllers.home-page-controller.satisfaction",
        "defaultMessage": "Satisfaction"
    },
    requestsDeflected: {
        "id": "spa-apps-servicedesk-reports-home-page.controllers.home-page-controller.requests-deflected",
        "defaultMessage": "Requests deflected"
    },
    requestsResolved: {
        "id": "spa-apps-servicedesk-reports-home-page.controllers.home-page-controller.requests-resolved",
        "defaultMessage": "Requests resolved"
    },
    analytics: {
        "id": "spa-apps-servicedesk-reports-home-page.controllers.home-page-controller.analytics",
        "defaultMessage": "Atlassian Analytics"
    }
});

});


parcelRegister("6PXzk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a90c080e3af69139$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a90c080e3af69139$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    searchPlaceholder: {
        "id": "spa-apps-servicedesk-reports-home-page.search-placeholder",
        "defaultMessage": "Search for reports"
    },
    swithcToListViewButton: {
        "id": "spa-apps-servicedesk-reports-home-page.swithc-to-list-view-button",
        "defaultMessage": "Switch to list view"
    },
    swithcToCardViewButton: {
        "id": "spa-apps-servicedesk-reports-home-page.swithc-to-card-view-button",
        "defaultMessage": "Switch to card view"
    },
    emptyStateHeader: {
        "id": "spa-apps-servicedesk-reports-home-page.empty-state-header",
        "defaultMessage": "Reports aren\u2019t available"
    },
    emptyStateDescription: {
        "id": "spa-apps-servicedesk-reports-home-page.empty-state-description",
        "defaultMessage": "It looks like you\u2019ve not gained permission to reports yet. When your account admin adds you to reports, we\u2019ll list them here."
    },
    searchEmptyStateTitle: {
        "id": "spa-apps-servicedesk-reports-home-page.search-empty-state-title",
        "defaultMessage": "We couldn\u2019t find anything matching your search"
    },
    searchEmptyStateDescription: {
        "id": "spa-apps-servicedesk-reports-home-page.search-empty-state-description",
        "defaultMessage": "Try again with a different term"
    }
});

});




//# sourceMappingURL=async-servicedesk-reports-home-page.44b21039.js.map
